'use client'
import * as THREE from '../assets/js/engines/three/three.module';
import { Car, Character, keysActions, getAssetImage, getTimeTxt, CircuitRace, Track, sleep } from '../assets/js/cc.js';
import { RT_DIFF, RT_COAT } from '../assets/js/engines/engine_base';
import { PhysicMain, meshsInfos, frameTime, initAmmo } from '../lib/physic.js';

import { TextGeometry } from '../assets/js/engines/three/examples/jsm/geometries/TextGeometry.js';

import { mergeGeometries } from "../assets/js/rt/BufferGeometryUtils.js";
import { Transformation3 } from '../assets/js/engines/transform.js';


import { ScreenBase } from './screen_base.ts';        
import { ANCHOR, BACKPACK, BACKPACKAPP, BC_SOLANA, BC_WAX, getAssets, getCar, getDamage, getDemoCars,checkquest, getUserInfos, PHANTOM, PHANTOMAPP, WCW } from '../lib/blockchainSession.ts';
import { backpackLogin, linkLogin, phantomLogin, waxlogin } from '../lib/wallets.ts';
import { initanchor, initdmgWax, initwax, resetwax } from '../lib/actionsWax';
import { initdmgSOL, initsolana, resetsolana } from '../lib/actionsSol.ts';
        
var selectedServer = 0;
var Ammo = null;

const songs = [{
    "artist" : "remixedcat",
    "file": "Along_For_A_Sweet_Ride.mp3",
    "title": "Along For A Sweet Ride"
},{
    "artist" : "remixedcat",
    "file": "Battleships_Ready.mp3",
    "title": "Battleships Ready"
},{
    "artist" : "naamlock zar",
    "file": "Chapter 02 - Freebase in the Maze.mp3",
    "title": "Chapter 02 - Freebase in the Maze"
},{
    "artist" : "Kibutz",
    "file": "Lost in the circuit1_Kibutz.mp3",
    "title": "Lost in the circuit1"
},{
    "artist" : "remixedcat",
    "file": "The_Kitty_Cat_Way.mp3",
    "title": "The Kitty Cat Way"
},{
    "artist" : "remixedcat",
    "file": "Galactic_Gems.mp3",
    "title": "Galactic Gems"
},{
    "artist" : "remixedcat",
    "file": "Into_The_Storm.mp3",
    "title": "Into The Storm"
}
];

const prizes = {
    'buggy': 'assets/img/rewards/buggy_prize.png',
    'pickup': 'assets/img/rewards/car3_prize.png',
    'racing': 'assets/img/rewards/car4_prize.png',
    'davinci': 'assets/img/rewards/davinci_prize.png',
    'upgrade': 'assets/img/rewards/c2b.png',
    'cash': 'assets/img/rewards/cash.png',
    
};

const pointer = new THREE.Vector2();
const raycaster = new THREE.Raycaster();

const camPoints = { 'bar' : 
                    { pos : new THREE.Vector3(4.433935642242432, 1.0, 3.058720350265503), 
                        rot : new THREE.Quaternion(0.0, 0.0, 0.0, 1.0)
                    },
                    'tracks' : 
                    { pos : new THREE.Vector3(-2.0910515785217285, 1.0, 19.048828125), 
                        rot : new THREE.Vector3(0.005771965121075308, 0.0017153731944889387, -0.000009901253936870831, 0.9999818519296352)
                    },
                    'cars' : 
                    { pos : new THREE.Vector3(-5.059058666229248, 1.0, 21.421798706054688), 
                        rot : new THREE.Vector3(-0.003675558765446436,0.9478925043959607,0.010942968119520986,0.31838113436686655)
                    },
                    'rewards' : 
                    { pos : new THREE.Vector3(-5.059058666229248, 1.0, 21.421798706054688), 
                        rot : new THREE.Vector3(-0.003675558765446436,0.9478925043959607,0.010942968119520986,0.31838113436686655)
                    }
                }
                

                
var pressed = {};
let touches = [];
let clickedUI = { accel: false, brake: false };
const relative = true;
let lastEul = null;
let lastX = 0;
let lastY = 0;
let clicked = false;
let pingServers = null;


async function updateServers() {
    const res = await fetch('/api/status');
    const d = await res.json();

    const main = document.getElementById('server-list');
    main.innerHTML = '';

    for (const serv of d) {
        const div = document.createElement('div');
        div.className = "row game-server";


        const select = document.createElement('div');
        select.className = "col";

        const radio = document.createElement('input');
        radio.type = "radio";
        radio.name = "server-selected";
        radio.id = "game-server-" + serv.id;
        radio.value = serv.id;

        radio.addEventListener('change', function () {
            selectedServer = parseInt(this.value);
        })

        if (selectedServer === serv.id) {
            radio.checked = "checked";
        }

        select.appendChild(radio);
        div.appendChild(select);

        const name = document.createElement('div');
        name.className = "col big-opt";
        name.innerHTML = serv.name;
        div.appendChild(name);

        const ping = document.createElement('div');
        ping.className = "col";
        ping.id = 'server-ping-' + serv.id;
        ping.innerHTML = '---';
        div.appendChild(ping);

        const addr = document.createElement('div');
        addr.className = "col big-opt";
        addr.innerHTML = serv.addr;
        div.appendChild(addr);

        const port = document.createElement('div');
        port.className = "col big-opt";
        port.innerHTML = serv.port;
        div.appendChild(port);

        const location = document.createElement('div');
        location.className = "col";
        location.innerHTML = serv.location;
        div.appendChild(location);

        const nGames = document.createElement('div');
        nGames.className = "col big-opt";
        nGames.innerHTML = serv.nGames + '/' + serv.maxGames;
        div.appendChild(nGames);

        const nQueued = document.createElement('div');
        nQueued.className = "col";
        nQueued.innerHTML = serv.nQueued;
        div.appendChild(nQueued);

        //pingServer(serv);
        main.appendChild(div);
    }

    pingServers = setTimeout(updateServers, 4000);
}

export default class Lobby extends ScreenBase{

        panels;
        buttons;
        envTxt;
        racetypeTxt;
        gametypeTxt;
        movingObjects;
        ringObjects;
        selectCarScreens;
        currentInfoMsg;
        infoMessage;
        carSelectMode;
        firstElement;
        gameControls;
        loadingController;
        trackThumbs;
        currentLevel;

        character;
        characterPHY;
        rankScreens;
        songScreens;
        wires;

        constructor(engine, screenChanger, renderMode, DAmmo, glDomRef, DomEvents, blockchaininfos, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus){

            super(engine, screenChanger, renderMode, DAmmo, glDomRef, DomEvents, blockchaininfos, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus);

            this.userBalance= {stl : '-', main : '-'};

            Ammo = DAmmo;

            this.started = false;
            this.name = 'lobby';
            
            this.curFlag = 0;
            this.firstFrame = true;
            this.missionCar = null;
            this.firstStart = true;

            this.initDMGMat = new THREE.MeshBasicMaterial({color: 0xFFFFFF});
            this.initDMGMat.name = 'initdmg';

            this.timeDMGMat = new THREE.MeshBasicMaterial({color: 0x000000});
            this.timeDMGMat.name = 'timedmg';

            this.DMGMat = new THREE.MeshBasicMaterial({color: 0x00FF00});
            this.DMGMat.name = 'dmg';

            this.currentTrackClass = 'C';
            this.gameMode = 'new';
            this.selectedGame = -1;

            this.initDMGTxt = null;
            this.dmgMesh = null;
            this.DMGTxt = null;
            
            this.animReq = null;
            this.characterPHY = null;

            this.selectedSong = -1;

            this.screenChanger = screenChanger;
            
            this.curEngine = engine;
            
            this.world = new CircuitRace(this.curEngine);
            this.world.track = new Track(0, blockchaininfos.baseAddr);

            this.character = new Character(this.world.track.lastId++, {radius: 0.5, height: 8, speed: 0.2})
            this.character.ppos = new THREE.Vector3();

            this.phys = null;
            this.hover = {};

            this.world.engine = this.curEngine;
            this.isLoading = false;

            this.wires = [];
            this.panels =  [];
            this.buttons = []
            this.envTxt = [];
            this.racetypeTxt = [];
            this.netTexts = [];
            this.gametypeTxt = [];
            this.movingObjects = [];
            this.ringObjects= [];
            this.selectCarScreens = [];
            this.tracks = [];
            this.trackThumbs = [];
            this.rankScreens = [];
            this.songScreens = [];
            this.dialogAnswers = [];
            this.dialogOptions= null;
            this.currentLevel = null;

            this.map = { worldMap: null, levels: [] };
            
            this.trackTimePos = new THREE.Vector3();
            this.trackTimeQuat = new THREE.Quaternion();;
            this.trackBonusPos = new THREE.Vector3();
            this.trackBonusQuat = new THREE.Quaternion();;

            this.firstElement = 0;
            this.firstSong = 0;
            this.carSelectMode = 0;
            this.camVAngle = 0;

            this.currentInfoMsg = null;
            this.infoMessage = null;

            this.gameControls = null;
            this.loadingController = null;
            
            this.raceType = 'practice';
            this.envType = 'normal';


            this.firstTrackElement = 0;
            this.firstGameElement = 0;
            this.trackPanel = [ {thumb : null, reward : null, bonus : null, time : null},
                                {thumb : null, reward : null, bonus : null, time : null},
                                {thumb : null, reward : null, bonus : null, time : null},
                                {thumb : null, reward : null, bonus : null, time : null}];
        }

        
        setUserInfos(userInfos, gameConfig)
        {
            super.setUserInfos(userInfos, gameConfig);

            if(this.started){
                this.updateTrackList(this.currentTrackClass);
                this.updateWalletSelected();
                this.updateCoinIcon();
                this.updatePrizesTex();
                this.updateTrackRanks(null);

                this.getCarList().then(()=>{this.updateCarList(); this.initSelectableCars();})
  
                if(this.world.myCar){
                    this.curEngine.removeMeshChild(this.podcar, this.carGroup);
                    this.curEngine.removeCar(this.world.myCar);
                    this.world.myCar = null;
                }

                if(this.blockchaininfos.selectedCarid)
                    this.updateCar(this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype);

            }
        }

        teleportPlayer(point){
            this.character.pos.set(camPoints[point].pos.x, camPoints[point].pos.y, camPoints[point].pos.z);
            this.character.rot.set(camPoints[point].rot.x, camPoints[point].rot.y, camPoints[point].rot.z, camPoints[point].rot.w);

            const origin = new Ammo.btVector3(this.character.pos.x, this.character.pos.y, this.character.pos.z);  
            this.characterPHY.ammoData.char.warp(origin);
        }

    
        UIDraw(pipeline)
        {
            const curEngine = this.curEngine;

            if(this.isLoading === true) {
                curEngine.drawSprite(this.loadingController.loading1.spriteGPU, pipeline);
                curEngine.drawSprite(this.loadingController.loading2.spriteGPU, pipeline);
                curEngine.drawMesh(this.loadingController.txt.meshGPU, pipeline);
            }
            
            if((this.started)&&(curEngine.useMobileUI)){
                curEngine.drawSprite(this.gameControls.accel.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.brake.spriteGPU, pipeline);
            }
         }

        
        drawBone(bone, t, pipeline){
            
            t.set(bone.obj.position, bone.obj.quaternion);
            this.curEngine.updateTransform(bone.obj, t);
            this.curEngine.drawMesh(bone.obj.meshGPU, pipeline);

            for(let child of bone.children) {
                this.drawBone(child, t, pipeline);
            }

        }

        mainDraw(pipeline){
            const curEngine = this.curEngine;
            const t = new Transformation3();

            if((this.trackPod)&&(this.trackPod.meshGPU))
                curEngine.drawMesh(this.trackPod.meshGPU, pipeline);
            
            for(let w of this.wires){
                t.set(w.position, w.quaternion);
                curEngine.updateTransform(w, t);

                curEngine.drawMesh(w.meshGPU, pipeline);
            }


            if(this.podcar)
                curEngine.drawMesh(this.podcar.meshGPU, pipeline);
            
            for(let n =0; n< this.world.track.cyls.length;n++){
                const c = this.world.track.cyls[n];
                if(c.mesh){
                    curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                }
            }

            if(this.walletBoard){
                curEngine.drawMesh(this.walletBoard.meshGPU,pipeline);
            }
            

            //const t = new Transformation3();

            if((this.spider)&&(this.spider.skel)&&(this.spider.skel.root.obj.meshGPU)){
                this.drawBone(this.spider.skel.root, t,  pipeline);
            }
            

            for(let w of this.ringObjects){
                curEngine.drawMesh(w.meshGPU, pipeline);
            }
    

            for (let o of this.movingObjects) {
                curEngine.drawMesh(o.meshGPU, pipeline);
            }

            if((this.trackList)&&(this.trackList.meshGPU)){

                t.set(this.trackList.position, this.trackList.quaternion);
                curEngine.updateTransform(this.trackList, t);
                curEngine.drawMesh(this.trackList.meshGPU, pipeline);
            }
                

            if(this.initDMGTxt){
                t.set(this.initDMGTxt.position, this.initDMGTxt.quaternion);
                curEngine.updateTransform(this.initDMGTxt, t);
                curEngine.drawMesh(this.initDMGTxt.meshGPU, pipeline);
            }

            if(this.dmgMesh){
                curEngine.drawMesh(this.dmgMesh.meshGPU, pipeline);
            }

            if(this.DMGTxt){
                curEngine.drawMesh(this.DMGTxt.meshGPU, pipeline);
            }
            

            /*
            if(this.currentLevel){
                curEngine.drawMesh(this.trackThumbs[this.currentLevel].text.meshGPU, pipeline);
                curEngine.drawMesh(this.trackThumbs[this.currentLevel].time.meshGPU, pipeline);
                curEngine.drawMesh(this.trackThumbs[this.currentLevel].bonus.meshGPU, pipeline);
            }
            */

            if((this.npc1)&&(this.npc1.avatarMesh))
                curEngine.drawMesh(this.npc1.avatarMesh.meshGPU, pipeline);


            if(this.worldObjs){
                
                for(let c of this.worldObjs){

                    t.set(c.position, c.quaternion);
                    curEngine.updateTransform(c, t);

                    curEngine.drawMesh(c.meshGPU, pipeline);
                    //c.meshGPU = this.curEngine.addMesh(c);
                }
            }

            if(this.map.worldMap)
                curEngine.drawMesh(this.map.worldMap.meshGPU, pipeline);

            if(pipeline !== 'shadow'){
                if(this.dialogOptions){
                    curEngine.drawMesh(this.backGround.meshGPU, pipeline);

                    const txtTime = 2000;
                    const now = new Date().getTime();
                    const dt = Math.min(txtTime, now - this.dialogStart);

                    const nchars = parseInt((this.dialogLineTxt.chars.length * dt) / txtTime);

                    for(let n = 0; n<nchars;n++){
                        const c = this.dialogLineTxt.chars[n];
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }

                    if(dt>= txtTime){
                        curEngine.drawMesh(this.dialogOptions.meshGPU, pipeline);

                        for(let a of this.dialogAnswers){
                            for(let c of a.txt.chars){
                                curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                            }
                        }
                    }
                }
            }
        }

     

        findTrack(name) {
            for (let n = 0; n < this.tracks.length; n++) {
                if (this.tracks[n].name == name)
                    return this.tracks[n];
            }
            return null;
        }
        updateRaceType(type) {
            this.raceType = type;
        }

        updateEnv(type) {
            this.envType = type;
        }
        
        

        fixmat(name, mat){

            if(mat.name.startsWith('Glass')){
                mat.transparent = true;
                mat.opacity = 0.75;
            }else if(name.startsWith('wall')){

                if(mat.name === 'wall-emm'){
                    mat.toneMapped = false;
                    mat.envMapIntensity = 32.0;
                }
            }else
                mat.envMapIntensity = 0.2;

        }
        fixmesh(mesh){

            if ((mesh.name.startsWith('wall')) || (mesh.name.startsWith('floor')))
                mesh.castShadow = false;
            else
                mesh.castShadow = true;

            if (mesh.name.startsWith('wall'))
                mesh.receiveShadow = false;
            else
                mesh.receiveShadow = true;


            if(mesh.name.startsWith('floor')){
                mesh.material.roughness = 0.2;
                mesh.material.envMapIntensity = 0.4;
                mesh.material.reflectivity = 2.0;
            }else{

            if(mesh.material.length > 0){
                for(let mat of mesh.material){
                    this.fixmat(mesh.name, mat);
                }
            }
            else
                this.fixmat(mesh.name, mesh.material);
        }                    
    }



        updateWalletSelected(){

            for (var b of this.buttons) {

                if (b.panel === 'wallets')  {
        
                    let selected = false;
                    let disabled = false;

                    if(b.name.startsWith('waxlogin')){
                        disabled = (this.selectedBlockchain == BC_WAX) && (this.selectedNetwork == 'mainnet') ? false : true;
                        selected = this.blockchaininfos.logType == WCW? true : false;
                    }
                    if(b.name.startsWith('anchorlogin')){
                        selected = this.blockchaininfos.logType == ANCHOR? true : false;
                        disabled = (this.selectedBlockchain !== BC_WAX) ? true : false;
                    }
                    if(b.name.startsWith('phantomlogin')){
                        selected = this.blockchaininfos.logType == PHANTOM || this.blockchaininfos.logType == PHANTOMAPP ? true : false;
                        disabled = this.selectedBlockchain === BC_SOLANA && this.selectedNetwork !== 'localnet'? false : true;
                    }
                    if(b.name.startsWith('backpacklogin')){
                        selected = this.blockchaininfos.logType == BACKPACK || this.blockchaininfos.logType == BACKPACKAPP ? true : false;
                        disabled = this.selectedBlockchain == BC_SOLANA ? false : true;
                    }

                    b.selected = selected;
                    b.disabled = disabled;
                    this.setButtonState(b, b.disabled ? 2 : b.selected ? 1 :0);
                }

                if (b.panel === 'login')  {
        
                    let selected = false;
                    let disabled = false;

                    
                    if(b.name.startsWith('solana')){
                        selected = (this.selectedBlockchain == BC_SOLANA) ? true : false;
                    }
                    if(b.name.startsWith('wax')){
                        selected = (this.selectedBlockchain == BC_WAX) ? true : false;
                        disabled = this.selectedNetwork == 'localnet' ? true  : false ;
                    }

                    if(b.name.startsWith('mainnet'))
                        selected = (this.selectedNetwork == 'mainnet') ? true  : false ;

                    if(b.name.startsWith('testnet'))
                        selected = (this.selectedNetwork == 'testnet')  ? true : false ;

                    if(b.name.startsWith('localnet')){
                        selected = (this.selectedNetwork == 'localnet') ? true : false ;
                        disabled = (this.selectedBlockchain !== BC_SOLANA) ? true : false;
                    }
                        
                    b.selected = selected;
                    b.disabled = disabled;
                    this.setButtonState(b, b.disabled ? 2 : b.selected ? 1 :0);
                }
            }
        }

        async parseLobbyObj(child){

            const world = this.world;
            const curEngine = this.curEngine;
            const self = this;

           
            if (child.type !== 'Mesh') {
                console.log(child.type);
                return;
            }

            if (child.name.startsWith('trigger-')){

                const name = child.name.substr(8);

                child.geometry.computeBoundingBox();
                const box = child.geometry.boundingBox;
                const center = new THREE.Vector3();
                const size = new THREE.Vector3();
                
                box.getCenter(center);
                box.getSize(size);

                center.add(child.position);

                child.visible = false;

                world.track.triggers.push({type: name, size : size, pos: center, rot: child.quaternion.clone()});
            }else if (child.name.startsWith('pod-car')) {
                self.podcar = child;
                const gc = new THREE.Vector3();
                const pos = child.position.clone();
                const size = new THREE.Vector3();

                let bb = new THREE.Box3().setFromObject(child);

                bb.getCenter(gc);
                bb.getSize(size);

                size.multiplyScalar(0.5);

                const tbox = new THREE.Box3(new THREE.Vector3(pos.x - size.x, pos.y - 5, pos.z - size.z), 
                                            new THREE.Vector3(pos.x + size.x, pos.y + 5, pos.z + size.z));

                const cyl = { name : child.name, box : tbox, pos: pos, gc: gc, radiusX: size.x, radiusZ: size.z, height: 10.0, mass: 0, rot: new THREE.Quaternion(), deltaPhys : new THREE.Vector3() };
                world.track.cyls.push(cyl);

            } else if (child.name.startsWith('panel-jukebox')) {
                const gc = new THREE.Vector3();
                const pos = child.position.clone();
                const size = new THREE.Vector3();

                let bb = new THREE.Box3().setFromObject(child);

                bb.getCenter(gc);
                bb.getSize(size);

                size.multiplyScalar(1.2);
                
                const tbox = new THREE.Box3(new THREE.Vector3(pos.x - size.x / 2.0, pos.y - size.y / 2.0, pos.z - size.z / 2.0), 
                                            new THREE.Vector3(pos.x + size.x / 2.0, pos.y + size.y / 2.0, pos.z + size.z / 2.0));

                const cube = { name: child.name, pos: pos, gc: gc, size: size, box : tbox, mass: 0, rot: new THREE.Quaternion(), margin: 2.5 };
                world.track.cubes.push(cube);

            }else if (child.name.startsWith('light')){

                const col = child.material.color;
                const sp = {};

                child.visible = false;

                const dir = new THREE.Vector3(0,0,1).applyQuaternion(child.quaternion).multiplyScalar(100.0);

                sp.light = new THREE.SpotLight(col.getHex(), 1.5, 155, Math.PI , 0.2,  0.1 );
                sp.light.position.set(child.position.x, child.position.y, child.position.z);
                //sp.light.position.add(this.world.track.terrain.offset);
        
                sp.geom = new THREE.BoxGeometry(0.001, 0.001, 0.001, 1, 1, 1);
                sp.target = new THREE.Mesh(sp.geom, this.SphereMaterial );
                sp.target.position.addVectors(sp.light.position, dir );
        
                sp.light.target = sp.target;
                curEngine.scene.add(sp.target);
                curEngine.scene.add(sp.light);

                this.world.track.terrain.lights.push(sp);
        
                
            }else if ( (child.name.startsWith('Wheel'))) {

                const o = child;
                o.position.set(o.position.x + this.world.track.terrain.offset.x, o.position.y + this.world.track.terrain.offset.y, o.position.z + this.world.track.terrain.offset.z);
                this.world.track.terrain.movingTerrain.push(o);
            }
        
            if(child.material.length>0){
                for(let imat =0; imat<child.material.length;imat++){
                    
                    const m = child.material[imat];

                    if(m.name.startsWith('Toon')){
                        const mat = curEngine.setToon(m);
                        child.material[imat] = mat;
    
                        const ng = curEngine.addFlippedGeo(child.geometry, child.geometry.groups[imat]);
                        const toonMesh = new THREE.Mesh(ng, curEngine.toonFlippedMat);
                        child.add(toonMesh);
                    }
                }
            }

            if (child.name.startsWith('panel-')) {

                const arr = child.name.split('-');
                const panel = arr[1];

                if(!(child.material.length >0)){
                    console.log('child no mat '+child.name);
                    return;
                }

                child.geometry.computeBoundingBox();
                const box = child.geometry.boundingBox;
                const center = new THREE.Vector3();
                const size = new THREE.Vector3();
                    
                box.getCenter(center);
                box.getSize(size);

                center.add(child.position);
                world.track.colcubes.push({name : child.name, size : size, pos: center, rot: child.quaternion.clone()});

                //for (let c of child.children) 
                for (let m of child.material)  {

                    if (panel === 'track') {

                        if (m.name == 'level-thumb') {
                            self.levelThumb = {o : child, m: m};
                        }
                    }

                    if (panel === 'account') {

                        if(m.name === 'coin-icon') {
                            this.coinIcon = {o : child, m : m};
                        }
                    }

                    if (panel === 'wallets') {

                        this.walletBoard = child;

                        const arr = m.name.split('-');
                        const type = arr[1];

                        let selected = false;
                        let disabled = false;
                        let grp = '';

                        if(!(m.name.startsWith('board'))){

                            const na = this.blockchaininfos.network.split('-');
                            this.selectedNetwork = na[1];

                            if(m.name.startsWith('waxlogin')){
                                grp = 'wallets';
                                selected = this.blockchaininfos.logType == WCW;
                                disabled = this.blockchaininfos.bc_type == BC_WAX && this.selectedNetwork == 'mainnet' ? false : true;
                            }

                            if(m.name.startsWith('anchorlogin')){
                                grp = 'wallets';
                                selected = this.blockchaininfos.logType == ANCHOR;
                                disabled = this.blockchaininfos.bc_type == BC_WAX ? false : true;
                            }

                            if(m.name.startsWith('phantomlogin')){
                                grp = 'wallets';
                                selected = (this.blockchaininfos.logType == PHANTOM)||(this.blockchaininfos.logType == PHANTOMAPP) ? true : false;
                                disabled = this.selectedNetwork !== 'localnet' && this.selectedBlockchain === BC_SOLANA? false : true;
                            }

                            if(m.name.startsWith('backpacklogin')){
                                grp = 'wallets';
                                selected = (this.blockchaininfos.logType == BACKPACK)||(this.blockchaininfos.logType == BACKPACKAPP) ? true : false;
                                disabled = this.blockchaininfos.bc_type == BC_SOLANA ? false : true;
                            }


                            const unselable = (m.name.endsWith('-cont')||m.name.endsWith('-txt')) ? true : false;

                            if(!m.name.endsWith('-txt')){
                                curEngine.addSelectable(this.walletBoard, m);
                                self.buttons.push({ obj: this.walletBoard, panel: panel, name: m.name, group: grp, value: type, selected: selected , unselable: unselable, disabled : disabled});
                            }
                        }
                    }

                    if (panel === 'login') {
                        const arr = m.name.split('-');
                        const type = arr[1];

                        let selected = false;
                        let disabled = false;
                        let grp = '';

                        if(!(m.name.startsWith('board'))){

                           
                            if(m.name.startsWith('wax')){
                                grp = 'login';
                                selected = (this.bc_type == BC_WAX) ? true : false ;
                                disabled = this.selectedNetwork == 'localnet' ? true : false;
                            }

                            if(m.name.startsWith('solana')){
                                grp = 'login';
                                selected = (this.bc_type == BC_SOLANA) ? true : false ;
                            }

                            
                            if(m.name.startsWith('mainnet')){
                                grp = 'net';
                                selected = (this.selectedNetwork == 'mainnet') ? true : false ;

                                if(m.name.endsWith('-txt'))
                                    this.netTexts['mainnet'] = {o : child, m: m};
                            }

                            if(m.name.startsWith('testnet')){
                                grp = 'net';
                                selected = (this.selectedNetwork == 'testnet') ? true : false ;

                                if(m.name.endsWith('-txt'))
                                    this.netTexts['testnet'] = {o : child, m: m};
                            }

                            if(m.name.startsWith('localnet')){
                                grp = 'net';
                                selected = (this.selectedNetwork == 'localnet') ? true : false ;

                                if(m.name.endsWith('-txt'))
                                    this.netTexts['localnet'] = {o : child, m: m};

                                disabled = this.blockchaininfos.bc_type == BC_SOLANA ? false : true;
                            }

                            const unselable = (m.name.endsWith('-cont')||m.name.endsWith('-txt')) ? true : false;

                            if(!m.name.endsWith('-txt')){
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: panel, name: m.name, group: grp, value: type, selected: selected , unselable: unselable, disabled : disabled});
                            }
                        }
                    }

                    if (panel === 'gametype') {

                        const arr = m.name.split('-');
                        const type = arr[1];
                        const selected = (type === 'new') ? true : false;
                        const unselable = m.name.endsWith('-cont') ? true : false;

                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: panel, name: m.name, group: "gametype", value: type, selected: selected , unselable: unselable});
                    }

                    if (panel === 'start') {
                        const unselable = m.name.endsWith('-cont') ? true : false;
                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: 'start', name: m.name, group: "start", selected: false, unselable: unselable });
                    }

                    if (panel === 'missionsok') {
                        const unselable = m.name.endsWith('-cont') ? true : false;
                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: 'missionsok', name: m.name, group: "missionsok", selected: false, unselable: unselable });
                    }

                    if (panel === 'missionsrefresh') {
                        const unselable = m.name.endsWith('-cont') ? true : false;
                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: 'missionsrefresh', name: m.name, group: "missionsrefresh", selected: false, unselable: unselable });
                    }

                    if (panel == 'weather') {
                        const arr = m.name.split('-');
                        const env = arr[1];

                        const selected = (env === 'normal') ? true : false;
                        const unselable = m.name.endsWith('-cont') ? true : false;

                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: panel, group : 'weather', name: m.name, value: env, selected: selected, unselable: unselable });
                    }

                    if (panel == 'tracklistnav') {
                        //self.trackList = child;

                        if (m.name === 'tracklist-next') {
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: panel, name: m.name, group : 'tracklist-nav', value: 'next', selected: false, unselable: false });
                        }

                        if (m.name === 'tracklist-previous') {
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: panel, name: m.name, group : 'tracklist-nav', value: 'next', selected: false, unselable: false });
                        }
                    }

        
                    if (panel == 'car') {

                        if (m.name === 'screen-carthumb') {
                            self.carThumb = {o : child, m: m.name};;
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: 'car', name: m.name });
                        }

                        if (m.name === 'screen-enginethumb') {
                            self.engineThumb = {o : child, m: m.name};;
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: 'car', name: m.name });
                        }

                        if (m.name === 'screen-tirethumb') {
                            self.tireThumb = {o : child, m: m.name};;
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: 'car', name: m.name });
                        }

                        if (m.name === 'car-damage') {

                            const matIdx = child.material.indexOf(m);
                            const sp = self.curEngine.getGeoGrpCenter(child.geometry, matIdx);

                            this.dmgCenter = sp.c.applyQuaternion(child.quaternion).add(child.position);
                            this.dmgQuat = child.quaternion.clone();
                            this.dmgSize = sp.s;

                            /*
                            self.tireThumb = {o : child, m: m.name};;
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: 'car', name: m.name });
                            */
                        }
                    }

                    if (panel == 'jukebox') {

                        const songname = m.name;
                        if(songname.startsWith('song')){

                            const postfix = songname.substr(4);
                            const grp = ((postfix =='up')||(postfix =='down')) ? 'songnav': 'songs';
                            const songid = ((postfix =='up')||(postfix =='down')) ? postfix : parseInt(postfix) -1;
                            const unselable = songname.endsWith('-cont') ? true : false;

                            const but = { obj: child, panel: panel, value: songid, group: grp, name: m.name, unselable: unselable };
                                    
                            curEngine.addSelectable(child, m);
                            self.buttons.push(but);
                        }
                    }

                    if (panel == 'selectcar') {

                        const carname = m.name;

                        if (carname.startsWith('selectcar')) {

                            const id = parseInt(carname[9]) - 1;
                                
                            const unselable = carname.endsWith('-cont') ? true : false;
                            const but = { obj: child, panel: panel, value: id, group: 'selectcar', name: m.name, unselable : unselable };

                            curEngine.addSelectable(child, m);
                            self.buttons.push(but);

                            if (!carname.endsWith('-cont')) {
                                const matCol = m.color.getHex();
                                m.color.setRGB(1, 1, 1);

                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');

                                const screen = { canvas: canvas, ctx: ctx, matCol: matCol, mesh: child, panel: panel, name: carname };

                                canvas.width = 512;
                                canvas.height = 512;

                                m.map = curEngine.createTextureCanvas(canvas, false);
                                self.selectCarScreens[id] = screen;
                            }
                        }

                        if (carname.startsWith('freecar')) {

                            if (carname.endsWith('-txt')) {
                                self.freecarTxt = {o : child, m: m};
                            } else {
                                const selected = ((world.myCar !== null) && (( self.carSelectMode === 0) && ((world.myCar.carDef.type == -1)))) ? true : false;
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: panel, name: m.name, group: 'cartype', selected: selected });
                            }
                        }

                        if (carname.startsWith('mycars')) {

                            if (carname.endsWith('-txt')) {
                                self.mycarsTxt = {o : child, m: m};
                            } else {
                                const selected = ((world.myCar !== null) && (( self.carSelectMode === 1) && ((world.myCar.carDef.type == -2) || (world.myCar.carDef.type > 0)))) ? true : false;
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: panel, name: m.name, group: 'cartype', selected: selected });
                            }
                        }

                        if (carname.startsWith('next-car')) {
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: panel, name: m.name, group : "car-nav" });
                        }

                        if (carname.startsWith('prev-car')) {
                            curEngine.addSelectable(child, m);
                            self.buttons.push({ obj: child, panel: panel, name: m.name, group : "car-nav" });
                        }
                    }

                    if (panel == 'racetype') {

                        const arr = m.name.split('-');
                        const racetype = arr[1];

                        const selected = (racetype === 'practice') ? true : false;
                        const unselable = m.name.endsWith('-cont') ? true : false;

                        curEngine.addSelectable(child, m);
                        self.buttons.push({ obj: child, panel: panel, group: 'racetype', name: m.name, value: racetype, selected: selected, unselable : unselable });
                    }

                    if (((panel == 'tclass') || (panel == 'rclass')) && (m.name.startsWith('class '))) {
                        
                        const arrr = m.name.split(' ');
                        const butclass = arrr[1];
                        const selected = (butclass === this.currentTrackClass) ? true : false;

                        const matIdx = child.material.indexOf(m);
                        child.material[matIdx] = m.clone();

                        curEngine.addSelectable(child, child.material[matIdx]);
                        self.buttons.push({ obj: child, panel: panel, value: butclass, name: m.name, selected: selected });
                    }

                    if (m.name.startsWith('screen-')) {

                        const ar = m.name.split('-');
                        const matCol = 0x4E7456;

                        m.color.setRGB(1, 1, 1);

                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        const screen = { canvas: canvas, ctx: ctx, matCol: matCol, mesh: child, panel: panel, name: ar[1] };


                        if (m.name === 'screen-missions') {
                            canvas.width = 512;
                            canvas.height = 512;
                            m.map = curEngine.createTextureCanvas(canvas, false);

                            this.missionScreen = screen;
                        }


                        if ((m.name === 'screen-carthumb') ||
                            (m.name === 'screen-enginethumb') ||
                            (m.name === 'screen-tirethumb') ||
                            (m.name === 'screen-carstats') ||
                            (m.name === 'screen-carmarket')
                            ) 
                        {
                            canvas.width = 512;
                            canvas.height = 512;
                            m.map = curEngine.createTextureCanvas(canvas, false);
                        }

                        if ((m.name === 'screen-rankinfos')) {

                            const id = parseInt(arr[2]) - 1;

                            canvas.width = 512;
                            canvas.height = 64;
                                
                            this.rankScreens[id] = screen;

                            const matIdx = child.material.indexOf(m);
                            child.material[matIdx] = m.clone();
                            child.material[matIdx].map = curEngine.createTextureCanvas(canvas, false);
                        }

                        if (m.name.startsWith('screen-song')) {

                            const id = parseInt(m.name.substr(11)) - 1;

                            canvas.width = 256;
                            canvas.height = 32;
                                
                            this.songScreens[id] = screen;
                                
                            const matIdx = child.material.indexOf(m);
                            child.material[matIdx] = m.clone();
                            child.material[matIdx].map = curEngine.createTextureCanvas(canvas, false);
                        }
                            
                        
                        if ((panel === 'account')||(panel === 'coin')||(panel === 'steel')) {

                            const ecanvas = document.createElement('canvas');
                            const ectx = ecanvas.getContext('2d');

                            canvas.width = 512;
                            canvas.height = 64;

                            ecanvas.width = 512;
                            ecanvas.height = 64;

                            screen.ecanvas = ecanvas;
                            screen.ectx = ectx;

                            m.map = curEngine.createTextureCanvas(canvas, false);
                            m.emissiveMap = curEngine.createTextureCanvas(ecanvas, false);

                            m.emissive.setRGB(1, 1, 1)
                            m.emissiveIntensity = 0.4;
                        }

                        if (panel === 'rewards') {
                            
                            canvas.width = 512;
                            canvas.height = 512;

                            m.map = curEngine.createTextureCanvas(canvas, false);
                            m.map.flipY = true;
                            const image = document.createElement('img');

                            if(prizes.hasOwnProperty(screen.name)){
                                image.src = prizes[screen.name];
                                screen.image = image;
                            }else
                                screen.image = null;
                        }
                        
                        if(panel === 'track') {

                            if (m.name == 'screen-levelname') {
                                canvas.width = 256;
                                canvas.height = 64;
                                m.map = curEngine.createTextureCanvas(canvas, false);
                                m.emissiveMap = curEngine.createTextureCanvas(  canvas, false);
                                m.emissive.setRGB(1,1,1);
                                m.emissiveIntensity = 8.0;
                            }
                        }

                        if ((panel === 'trackrewards') || (panel === 'infoblock')) {

                            canvas.width = 256;
                            canvas.height = 64;
                            m.map = curEngine.createTextureCanvas(canvas, false);
                        }
                        self.panels.push(screen);
                    }
                }
            }

            if ((child.name.startsWith('wall')) ||
                (child.name.startsWith('shelf')) ||
                (child.name.startsWith('bar')) ||
                (child.name.startsWith('floor'))) {

                const gc = new THREE.Vector3();
                const pos = child.position.clone();
                const size = new THREE.Vector3();

                if (child.name.startsWith('floor'))
                    self.floor = child;

                child.geometry.computeBoundingBox();
                child.geometry.boundingBox.getCenter(gc);
                child.geometry.boundingBox.getSize(size);

                if (child.name.startsWith('wall'))
                    size.multiplyScalar(1.2);

                if (size.x == 0)
                    size.x = 1.0;

                if (size.y == 0)
                    size.y = 0.2;

                if (size.z == 0)
                    size.z = 1.0;

                pos.add(gc);

                const tbox = new THREE.Box3( new THREE.Vector3(pos.x - size.x / 2.0, pos.y - size.y / 2.0, pos.z - size.z / 2.0), 
                                                new THREE.Vector3(pos.x + size.x / 2.0, pos.y + size.y / 2.0, pos.z + size.z / 2.0));


                const cube = { name: child.name, pos: pos, box: tbox, gc: gc, size: size, mass: 0, rot: child.quaternion.clone(), margin: 0.2 };
                world.track.cubes.push(cube);
            }

            if (child.name.startsWith('envtxt-')) {

                const arr = child.name.split('-');
                const env = arr[1];

                child.material = child.material.clone();
                self.envTxt[env] = {o : child, m: child.material};
            }

            if (child.name.startsWith('racetypetxt-')) {

                const arr = child.name.split('-');
                const env = arr[1];
                
                child.material = child.material.clone();
                self.racetypeTxt[env] = {o : child, m: child.material};
            }

            if (child.name.startsWith('gametypetxt-')) {

                const arr = child.name.split('-');
                const type = arr[1];

                child.material = child.material.clone();
                self.gametypeTxt[type] = {o : child, m: child.material};
            }

            if (child.name.startsWith('missionsoktxt')) {
                child.material = child.material.clone();
                self.missionsOkTxt = {o : child, m: child.material};
            }

            if (child.name.startsWith('starttxt')) {

                child.material = child.material.clone();
                self.startTxt = {o : child, m: child.material};
            }
        }
        
        async loadWorldMap(mapFile) {

            const world = this.world;
            const self = this;
            const curEngine = this.curEngine;

            const manager = new THREE.LoadingManager();
            manager.onProgress = function (url, itemsLoaded, itemsTotal) {
                self.loadingController.loading2.scale.x = itemsLoaded * 78 / itemsTotal;
            };

            const gltf = await this.curEngine.loadGLTF(mapFile, manager, this.loadingController, 6817 * 1024);
            if (!gltf)
                return;
    
            const worldMap = new THREE.Group();
            worldMap.name = 'world map group';
                
            gltf.traverse((child) => {

                if(child.name === 'Scene')
                    return;

                if (child.type === 'Mesh') {
                    child.geometry = child.geometry.clone()

                    if(child.parent.name === 'Scene'){

                        if (child.name == 'trackpod') {
                            this.trackPod = child;
                        }else if (child.name.startsWith('wire')) {
                            this.fixmesh(child);
                            child.geometry.scale(child.scale.x, child.scale.y, child.scale.z)
                            child.scale.set(1,1,1);
                            this.wires.push(child);
                        }else{
                            const cc = child.clone();
                            cc.geometry.scale(child.scale.x, child.scale.y, child.scale.z)
                            cc.scale.set(1,1,1);
                            this.fixmesh(cc);
                            worldMap.add(cc);
                        }
                    }

                }else if (child.type === 'Group') {

                    const geos = [];
                    const mats = [];

                    for(let cc of child.children){

                        if(cc.children.length > 0){
                            console.log('depth > 2');
                        }

                        geos.push(cc.geometry);

                        if(cc.material.length > 0){

                        }else{
                            mats.push(cc.material);
                        }
                    }

                    const newgeo = mergeGeometries(geos, true);

                    newgeo.scale(child.scale.x, child.scale.y, child.scale.z)

                    const newMesh = new THREE.Mesh(newgeo, mats);

                    newMesh.name = child.name;
                    newMesh.position.set(child.position.x, child.position.y, child.position.z);
                    newMesh.scale.set(1,1,1);
                    newMesh.quaternion.set(child.quaternion.x, child.quaternion.y, child.quaternion.z, child.quaternion.w);

                    this.fixmesh(newMesh);

                    if (newMesh.name == 'trackpod') {

                        this.trackPod = newMesh;

                    }else if (newMesh.name.startsWith('col-barrel')){

                        newMesh.geometry.computeBoundingBox();

                        const gc = new THREE.Vector3();
                        const gs = new THREE.Vector3();

                        newMesh.geometry.boundingBox.getCenter(gc);
                        newMesh.geometry.boundingBox.getSize(gs);
                        newMesh.geometry.translate(-gc.x, -gc.y, -gc.z);
                        newMesh.geometry.computeBoundingBox();

                        newMesh.position.add(gc);

                        const hgs = gs.clone().multiplyScalar(0.5);

                        const min = newMesh.position.clone().add(gs);
                        const max = newMesh.position.clone().sub(gs);

                        const tbox = new THREE.Box3(min, max);

                        const pos = newMesh.position.clone().add(gc);
                        const rot = newMesh.quaternion.clone();

                        const cyl = { name : newMesh.name, mesh : newMesh, box : tbox, pos: pos, rot: rot, gc: gc, radiusX: hgs.x, radiusZ: hgs.z, height: gs.y, friction : 0.5, mass: 15, stiffness: 0, heightOffset:0, deltaPhys : new THREE.Vector3() };
                        world.track.cyls.push(cyl);

                    }else if (child.name.startsWith('Wheel')) {
                        self.movingObjects.push(newMesh);

                        const gc = new THREE.Vector3();
                        const pos = newMesh.position.clone();
                        const size = new THREE.Vector3();

                        let bb = new THREE.Box3().setFromObject(child);

                        bb.getCenter(gc);
                        bb.getSize(size);

                        size.multiplyScalar(0.5);

                        const tbox = new THREE.Box3(new THREE.Vector3(pos.x - size.x, pos.y - 5, pos.z - size.z), 
                                                    new THREE.Vector3(pos.x + size.x, pos.y + 5, pos.z + size.z));

                        const cyl = { name : newMesh.name, box : tbox, pos: pos, gc: gc, radiusX: size.x, radiusZ: size.z, height: size.y * 2.0, mass: 0, rot: new THREE.Quaternion(), deltaPhys : new THREE.Vector3() };
                        world.track.cyls.push(cyl);

                    } else if (child.name.startsWith('ring')) {
                        const id = parseInt(child.name.substr(4))-1;
                        self.ringObjects[id] = child;
                        self.ringObjects[id].rectLight ={}; //new THREE.RectAreaLight(0x00FFFF, 1.0, 5, 5);

                        const p = new THREE.Vector3(child.position.x, child.position.y + 0.2, child.position.z);
                        const t = new THREE.Vector3(child.position.x, 0.0, child.position.z);
                        
                        curEngine.addRectLight(self.ringObjects[id].rectLight, p, t, {x:0,y:1,z:1}, 5, 5, 1.5);

                    } else
                        worldMap.add(newMesh);
                }
            });

            this.map.worldMap = worldMap;

        }

        async load(){

            const self = this;

            //await initAmmo();

            this.setactiveLinks({garage : true, play : false, selectCar : true, restart : false, lobby : false});

            this.mouseMoveFunc = function(e) {self.onPointerMove(e)};
            this.mouseDownFunc = function(e) {self.onClick(e)};
            this.mouseUpFunc = function(e) {self.unClick(e)}
            this.touchStartFunc = function(e) {self.onTouch(e)}
            this.mouseOutFunc = function(e) {self.onMouseOut(e)};

            this.touchMoveFunc = function(e) {self.touchMove(e)}
            this.touchEndFunc = function(e) {self.touchEnd(e)}

            this.keyDownFunc = function(e) {self.onKey(e)};
            this.keyUpFunc = function(e) {self.unKey(e)};
            this.resizeFunc = function (e) { 

                if(self.glDomRef.current)
                    self.curEngine.resizeCanvasToDisplaySize(self.glDomRef.current.offsetWidth, self.glDomRef.current.offsetHeight);
            }

            this.animateFunc = function(){self.animate();}

            this.phys = new PhysicMain(Ammo);
            this.isLoading = true;
            this.curEngine.renderMainScene = false;

            this.loadingController = await this.curEngine.createLoading();
            this.curEngine.addLoadingController(this.loadingController);
    
            this.curEngine.addSkyBox('nightsky.jpeg');

            if(this.renderMode === 2){
                this.curEngine.addRenderPass('render' , function(pipeline){ self.mainDraw(pipeline); } );
                this.curEngine.addRenderPass('shadow' , function(pipeline){ self.mainDraw(pipeline); } );
                this.curEngine.addRenderPass('ui' , function(pipeline){ self.UIDraw(pipeline) } );
                this.animReq = requestAnimationFrame(this.animateFunc);
            }else{
                this.curEngine.renderer.setAnimationLoop( this.animateFunc);
            }

            this.gameControls = await this.curEngine.makeLobbyUIButtons();
    
            this.waxIconTex = this.curEngine.texLoader.load('assets/img/wax-icon.png');
            this.solanaIconTex = this.curEngine.texLoader.load('assets/img/solana-icon.png');
    
            this.txtMat = new THREE.MeshPhysicalMaterial({ color: '#0F0', side: THREE.DoubleSide, transparent: true });
            this.txtMat.transmission = 0.8;
            this.txtMat.thickness = 0.8;
            this.txtMat.roughness = 0.0;
            this.txtMat.reflectivity = 0.1;
            this.txtMat.metalness = 0.0;
            this.txtMat.ior = 3;
            this.txtMat.depthTest = false;
            this.txtMat.castShadow = true;
            this.txtMat.receiveShadow = true;
    
            this.txtMat2 = new THREE.MeshBasicMaterial({ color: "#FFF", side: THREE.DoubleSide, transparent: false });
            this.curEngine.physicallyCorrectLights = true;
                
            await this.loadWorldMap('lobby');
        
            this.curEngine.setBumpSize( 2048, 2048, 4);

            /*
            const spider = await this.curEngine.loadSpider('spider');
            const skel = this.curEngine.getSpiderSkel(spider);
            const nBones = this.curEngine.getNbones(skel.root);

            let ofs = 0;
            this.spiderPose = new Float32Array(nBones * 7);
            this.curEngine.getBoneData(skel.root, this.spiderPose, ofs);

            this.spider= {id:1, obj : spider, skel : skel, nBones : nBones};

            console.log(this.spider);
            */


            this.isLoading = false;
            this.curEngine.renderMainScene = true;
            this.curEngine.removeLoading(this.loadingController);

            return true;
        }



        async start(){
            const self = this;

            this.panels = [];

            this.setactiveLinks({garage : true, play : false, selectCar : true, restart : false, lobby : false});

            await this.getMyCar(this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype);
            await this.getCarList()

            if(this.renderMode === 2){

                if(this.animReq === null){
                    this.curEngine.addRenderPass('render' , function(pipeline){ self.mainDraw(pipeline); } );
                    this.curEngine.addRenderPass('shadow' , function(pipeline){ self.mainDraw(pipeline); } );
                    this.curEngine.addRenderPass('ui' , function(pipeline){ self.UIDraw(pipeline) } );
                    this.animReq = requestAnimationFrame(this.animateFunc);
                }
            }else{
                this.curEngine.renderer.setAnimationLoop( this.animateFunc);
            }

            //this.curEngine.vertexAllocator.flag = this.curFlag;

            this.curEngine.numFrames = 0;

            clicked = false;

            this.lobbyLoaded = false;
            this.curEngine.camera.near = 0.1;
            this.curEngine.camera.far = 2000;
            
            this.curEngine.camera.fov = 65.0;
            this.curEngine.camera.updateProjectionMatrix();

            this.curEngine.initVR(function(on) { self.enableVR(on) });

            await this.startLobbyInside();


            //this.characterPHY = this.phys.addPhyCharacterController(this.character);

            this.curEngine.setSunLight(new THREE.Vector3(-50, 150, 100));
            this.curEngine.setShadowSource(new THREE.Vector3(-50, 150, 100));
            this.curEngine.setShadowProj(100, 100, 100);
            this.curEngine.setShadowBias(0.01);

            this.curEngine.addUIButtons(this.gameControls);
            this.initSensorEvents();
           
            if (this.curEngine.controller1) {

                this.selectStart1func = function (e) {

                    const controller = self.curEngine.controller1;

                    if (controller.hover.HoverButton != null) 
                        self.selectPanelButton( controller.hover.HoverButton.panel, 
                                                controller.hover.HoverButton.name, 
                                                controller.hover.HoverButton.group);

                    else if (controller.hover.HoveredChar != null) {

                        for(let nc =0; nc < self.world.track.npcs.length; nc++) {
            
                            if(self.world.track.npcs[nc].id === controller.hover.HoveredChar) {
            
                                if(self.world.track.npcs[nc].pos.distanceTo(self.character.pos)>=self.world.track.npcs[nc].avatarDef.activation)
                                    continue;
            
                                if(self.world.track.npcs[nc].dialog)
                                    self.curEngine.OpenDialog(self.world.track.npcs[nc]);
                            }
                        }

                    } else if(self.curEngine.vrTeleport1.canTeleport === true) {
                        const v = new THREE.Vector3(0,0, 1).applyQuaternion(self.curEngine.vrRay1.quaternion);
                        const a = Math.atan2(v.x, v.z);
                        const p = new THREE.Vector3(self.curEngine.vrTeleport1.position.x, self.character.pos.y, self.curEngine.vrTeleport1.position.z);
                        self.phys.teleportPhyChar(self.character.id, p, a);
                    }
                };

                

                this.curEngine.controller1.addEventListener('selectstart', this.selectStart1func);
            }
            
            if (this.curEngine.controller2) {

                this.selectStart2Func = function (e) {

                    const controller = self.curEngine.controller2;

                    if (controller.hover.HoverButton != null) 
                        self.selectPanelButton(controller.hover.HoverButton.panel, controller.hover.HoverButton.name, controller.hover.HoverButton.group);
                    else if (controller.hover.HoveredChar != null) {

                        for(let nc =0; nc < self.world.track.npcs.length; nc++) {
                
                            if(self.world.track.npcs[nc].id === controller.hover.HoveredChar) {
                
                                if(self.world.track.npcs[nc].pos.distanceTo(self.character.pos)>=self.world.track.npcs[nc].avatarDef.activation)
                                    continue;
                
                                if(self.world.track.npcs[nc].dialog)
                                    self.curEngine.OpenDialog(self.world.track.npcs[nc]);
                            }
                        }

                    } else if(self.curEngine.vrTeleport2.canTeleport === true) {

                        const v = new THREE.Vector3(0,0, 1).applyQuaternion(self.curEngine.vrRay2.quaternion);
                        const a = Math.atan2(v.x, v.z);
                        const p = new THREE.Vector3(self.curEngine.vrTeleport2.position.x, self.character.pos.y, self.curEngine.vrTeleport2.position.z);
                        self.phys.teleportPhyChar(self.character.id, p, a);
                    }
                }

                
                this.curEngine.controller2.addEventListener('selectstart', this.selectStart2Func);
            }

            this.curEngine.setBloomParams(0.5, 0.2, 0.6);

            switch(this.blockchaininfos.bc_type){
                case BC_WAX : this.targetWalletBoadAngle = Math.PI;break;
                case BC_SOLANA : this.targetWalletBoadAngle = 0.0;break;
            }
            this.firstFrame = true;

           

            this.addMainEvents();

            this.setactiveLinks({garage : true, selectCar : true, play : false, restart : false, lobby : false});

            this.started = true;
        }



        updateSongs(){

            if(this.firstSong === 0){

                const songupc = this.findPanelButton('jukebox', 'songup-cont');
                songupc.disabled = true;
                songupc.selected = false;
                const songup = this.findPanelButton('jukebox', 'songup');
                songup.disabled = true;
                songup.selected = false;
                this.setButtonState(songup, 2);

            }else{
                const songupc = this.findPanelButton('jukebox', 'songup-cont');
                songupc.disabled = false;
                songupc.selected = false;
                const songup = this.findPanelButton('jukebox', 'songup');
                songup.disabled = false;
                songup.selected = false;
                this.setButtonState(songup, songup.selected ? 1 : 0);
            }

            if((this.firstSong + 3 )>=songs.length){

                const songdownc = this.findPanelButton('jukebox', 'songdown-cont');
                songdownc.disabled = true;
                songdownc.selected = false;
                const songdown = this.findPanelButton('jukebox', 'songdown');
                songdown.disabled = true;
                songdown.selected = false;
                this.setButtonState(songdown, 2);

            }else{
                const songdownc = this.findPanelButton('jukebox', 'songdown-cont');
                songdownc.disabled = false;
                songdownc.selected = false;
                const songdown = this.findPanelButton('jukebox', 'songdown');
                songdown.disabled = false;
                songdown.selected = false;
                this.setButtonState(songdown, songdown.selected ? 1 : 0);
            }

            for (let i = 0; i < 3; i++) {

                if(i>=this.songScreens.length)
                    continue;

                const p = this.songScreens[i];
                const songid = this.firstSong + i;

                const ctx = p.ctx;
                ctx.fillStyle = '#' + p.matCol.toString(16);
                ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                const tid = i + 1;
                const b = this.findPanelButton('jukebox', 'song'+tid);
                const bc = this.findPanelButton('jukebox', 'song'+tid+'-cont');

                if(songid<songs.length){
                
                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "24px impact";
                    ctx.textAlign = 'left';
                    ctx.fillText(songs[songid].title+' - '+songs[songid].artist, 0, 24, 256);

                    if((b)&&(bc)){

                        if(this.selectedSong === songid) {
                            this.setButtonState(bc, 1);
                            b.selected = true;
                            bc.selected = true;
                        } else {
                            b.selected = false;
                            bc.selected = false;
                            this.setButtonState(bc, 0);
                        }
                    }
                } else {

                    if((b)&&(bc)){
                        this.setButtonState(bc, 2);
                        b.disabled = true;
                        bc.disabled = true;
                    }
                }
                this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
            }
        }

        prevTrack(){
            if(this.trackMoving === true)
                return;

            this.trackMoving = true;
            this.trackMovingDir = -1;
            this.trackMoveStart = new Date().getTime();

        }
        nextTrack(){

            if(this.trackMoving === true)
                return;


            this.trackMoving = true;
            this.trackMovingDir = 1;
            this.trackMoveStart = new Date().getTime();
        }


        prevGame(){
            if(this.trackMoving === true)
                return;

            this.trackMoving = true;
            this.trackMovingDir = -1;
            this.trackMoveStart = new Date().getTime();

        }
        nextGame(){

            if(this.trackMoving === true)
                return;


            this.trackMoving = true;
            this.trackMovingDir = 1;
            this.trackMoveStart = new Date().getTime();
        }

        async updateGameList(trackclass) {

            const classes = ['C', 'B', 'A'];
            const displayedGames = [];

            if(this.games.length<=0)
                return;

            let selected = null;
            let gselected = null;

            for (let i = 0; i < this.games.length; i++) {

                const track = this.findTrack(this.games[i].trackname);

                if(classes[track.class] === trackclass)
                    displayedGames.push(this.games[i]);
            }

            if(this.firstGameElement >= displayedGames.length)
                this.firstGameElement = 0;


            if(this.firstGameElement <= -displayedGames.length)
                this.firstGameElement = 0;


            let idx = this.firstGameElement;
            
            for (let i = 0; i < 4; i++) {
                const trackPanel = this.trackPanel[i];

                
                if(trackclass === 'A'){
                    let p = trackPanel.thumb;
                    let ctx = p.ctx;

                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "64px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("coming soon", 256, 256, 280);
                    this.curEngine.updateTex(p.mesh, p.name);


                    p = trackPanel.bonus;
                    ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    this.curEngine.updateTex(p.mesh, p.name);

                    p = trackPanel.time;
                    ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    this.curEngine.updateTex(p.mesh, p.name);

                    p = trackPanel.reward;
                    ctx = p.ctx;

                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    this.curEngine.updateTex(p.mesh, p.name);

                    continue;
                }


                if(idx >= displayedGames.length)
                    idx = 0;

                if(idx < 0)
                    idx += displayedGames.length;

                let index = idx;
                const game = displayedGames[index];
                const track = this.findTrack(game.trackname);

                if (!this.trackThumbs[track.name]) {
                    await this.createTrackThumbTex(track);
                }

                if(i === 1){
                    gselected = game;
                    selected = track.name;
                }

                const carImg = document.createElement('img');
                const curEngine = this.curEngine;

                const trackThumb = this.trackThumbs[track.name];

                const self = this;
                
                carImg.onload = function(){

                    if(trackThumb.img.complete){
                        const p = trackPanel.thumb;
                        const ctx = p.ctx;
                        
                        ctx.fillStyle = '#' + p.matCol.toString(16);
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                        ctx.fillStyle = '#000000';
                        ctx.strokeStyle = '#000000';
                        ctx.globalAlpha = 1.0;
                        ctx.font = "64px impact";
                        ctx.textAlign = 'center';
                        ctx.fillText('game id :'+game.id.toString(), p.canvas.width / 2, 64 , p.canvas.width);
                        ctx.fillText('host :' + game.account, p.canvas.width / 2, 128 , p.canvas.width);

                        ctx.drawImage(trackThumb.img, 0, p.canvas.height / 2, p.canvas.width / 2, p.canvas.height / 2);
                        ctx.drawImage(carImg, p.canvas.width / 2, p.canvas.height / 2, p.canvas.width / 2, p.canvas.height / 2);

                        curEngine.updateTex(p.mesh, p.name);
                    }else{
                        
                        const p1 = trackPanel.thumb;
                        const tb1 = self.trackThumbs[track.name];
                        
                        trackThumb.img.onload = function(){
                            const ctx1 = p1.ctx;

                            ctx1.fillStyle = '#' + p1.matCol.toString(16);
                            ctx1.fillRect(0, 0, p1.canvas.width, p1.canvas.height);
                            ctx1.fillStyle = '#000000';
                            ctx1.strokeStyle = '#000000';
                            ctx1.globalAlpha = 1.0;
                            ctx1.font = "64px impact";
                            ctx1.textAlign = 'center';
                            ctx1.fillText('game id :' +game.id.toString(), p1.canvas.width / 2, 64, p1.canvas.width);
                            ctx1.fillText('host : '+game.account, p1.canvas.width / 2, 128, p1.canvas.width);

                            ctx1.drawImage(tb1.img, 0, p1.canvas.height/2, p1.canvas.width / 2, p1.canvas.height/2);
                            ctx1.drawImage(carImg, p1.canvas.width / 2, p1.canvas.height/2, p1.canvas.width / 2, p1.canvas.height/2);

                            curEngine.updateTex(p1.mesh, p1.name);
                        }
                    }
                }
                carImg.crossOrigin = "";
                carImg.src = game.carimg;

                if(this.trackThumbs[track.name].rimg.complete){
                    const p = trackPanel.reward;
                    const ctx = p.ctx;

                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    ctx.drawImage(this.trackThumbs[track.name].rimg, 0, 0, p.canvas.width, p.canvas.height);
                    curEngine.updateTex(p.mesh, p.name);
                }else{

                    const self = this;
                    const p2 = trackPanel.reward;
                    const tb2 = self.trackThumbs[track.name];
                    
                    this.trackThumbs[track.name].rimg.onload = function(){
                        const ctx2 = p2.ctx;
                        ctx2.fillStyle = '#' + p2.matCol.toString(16);
                        ctx2.fillRect(0, 0, p2.canvas.width, p2.canvas.height);
    
                        ctx2.drawImage(tb2.rimg, 0, 0, p2.canvas.width, p2.canvas.height);
                        curEngine.updateTex(p2.mesh, p2.name);
                    }
                }


                let p;
                let ctx;
                p = trackPanel.bonus;
                ctx = p.ctx;
                ctx.fillStyle = '#' + p.matCol.toString(16);
                ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                ctx.fillStyle = '#000000';
                ctx.strokeStyle = '#000000';
                ctx.globalAlpha = 1.0;
                ctx.font = "32px impact";
                ctx.textAlign = 'left';
                ctx.fillText(track.nBonus, 16, 44, 280);
                this.curEngine.updateTex(p.mesh, p.name);

                p = trackPanel.time;
                ctx = p.ctx;
                ctx.fillStyle = '#' + p.matCol.toString(16);
                ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                ctx.fillStyle = '#000000';
                ctx.strokeStyle = '#000000';
                ctx.globalAlpha = 1.0;
                ctx.font = "32px impact";
                ctx.textAlign = 'left';
                ctx.fillText(track.lapTime, 16, 44, 280);
                this.curEngine.updateTex(p.mesh, p.name);

                idx++;
            }

            if(selected)
                this.updateLevel(selected);

            this.selectedGame = gselected;

            this.setStaticPanelButton('weather', 'env-'+this.selectedGame.envtype, 'weather');
        }

        findMountedCar(access){

            for(let car of this.blockchaininfos.assetLists['cars']){

                if(car[access])
                    return car;
            }

            return null;
        }


        updateMissionScreen(){

            const p = this.missionScreen;
            const ctx = p.ctx;

            /*
            ctx.fillStyle = '#' + p.matCol.toString(16);
            ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
            */

            ctx.scale(1.0 + (Math.random() - 0.5)* 0.05, 1.0 + (Math.random() - 0.5)* 0.05);
            ctx.drawImage(this.green_screen_img, 0, 0  ,  p.canvas.width, p.canvas.height);
            ctx.setTransform(1, 0, 0, 1, 0, 0);


            ctx.fillStyle = '#FFFFFF';
            ctx.strokeStyle = '#FFFFFF';
            ctx.globalAlpha = 1.0;
            ctx.font = "48px impact";
            ctx.textAlign = 'center';
            ctx.fillText("current mission", 256, 48, 512);

            switch(this.quests){
                default:
                            
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("no mission", 256, 256, 512);

                    this.disableMissionsUI();
                break;
                case 0:
                
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'left';
                    ctx.fillText("race to gain 20 STEEL", 64, 196, 512);
    
                    ctx.drawImage(this.steelImage, 128, 196, 128, 128);
                    ctx.fillText("X 20 ", 256, 284, 512);

                    

                    if(parseFloat(this.userBalance.stl)>=20){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';

                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);

                    }else{
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';

                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);

                    }
                    ctx.textAlign = 'center';

                    ctx.fillText(this.userBalance.stl +" / 20" , 256, 400, 512);
                break;

                case 1:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'left';
                    ctx.fillText("craft 10 nitros in the garage", 64, 196, 512);
    
                    ctx.drawImage(this.steelImage, 128, 196, 128, 128);
                    ctx.fillText("X 10 ", 256, 284, 512);

                    if(this.userInfos.nitros>=10){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);

                    }else{
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);

                    }
                    ctx.textAlign = 'center';

                    ctx.fillText(this.userInfos.nitros +" / 10" , 256, 400, 512);
                break;

                case 2:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("Find the battery blueprint in neon city", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    if(this.userInfos.bluePrints & 2){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 3:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("craft and mount a battery into a car", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    this.missionCar = this.findMountedCar('battery');

                    if( this.missionCar !== null){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 4:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("Find the radar blueprint in neon city", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    if(this.userInfos.bluePrints & 4){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 5:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("craft and mount a radar into a car", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    this.missionCar = this.findMountedCar('radar');

                    if( this.missionCar !== null){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 6:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("Find the weapon blueprint in neon city", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    if(this.userInfos.bluePrints & 8){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 7:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("craft and mount a weapon into a car", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    this.missionCar = this.findMountedCar('weapon');

                    if( this.missionCar !== null){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 8:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("Find the pickup blueprint in neon city", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    if(this.userInfos.bluePrints & 16){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

                case 9:
    
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("craft a pickup car", 256, 256, 512);
    
                    ctx.drawImage(this.steelImage, 192, 256, 128, 128);
                    
                    ctx.textAlign = 'center';

                    this.missionCar = this.findMountedCar('weapon');

                    if( this.missionCar !== null){
                        ctx.fillStyle = '#00FF00';
                        ctx.strokeStyle = '#00FF00';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = false;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("1 / 1" , 256, 400, 512);

                    } else {
                        ctx.fillStyle = '#FF0000';
                        ctx.strokeStyle = '#FF0000';
                        const b = this.findPanelButton('missionsok', 'missionsok');
                        b.disabled = true;
                        this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
                        ctx.fillText("0 / 1" , 256, 400, 512);
                    }
                break;

            }

            this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
        }

        disableMissionsUI(){

            const b = this.findPanelButton('missionsok', 'missionsok');
            b.disabled = true;
            this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);

            const b2 = this.findPanelButton('missionsrefresh', 'missionsrefresh');
            b2.disabled = true;
            this.setButtonState(b2, b2.disabled === true ? 2 : b2.selected ? 1 : 0);
        }

        async updateMission(){

            if(!this.missionScreen)
                return;

            if(this.blockchaininfos.myAccount == null){
                const p = this.missionScreen;
                const ctx = p.ctx;
                ctx.fillStyle = '#' + p.matCol.toString(16);
                ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                ctx.fillStyle = '#FFFFFF';
                ctx.strokeStyle = '#FFFFFF';
                ctx.globalAlpha = 1.0;
                ctx.font = "64px impact";
                ctx.textAlign = 'center';
                ctx.fillText("please login", 256, 256, 512);

                this.disableMissionsUI();

                this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                return;

            }

            this.userInfos = await getUserInfos(this.blockchaininfos);

            if(this.userInfos === null){
                this.setuserinfos({balance: this.userBalance, userInfos: {nitros: '-', techBalance: '-'}})
                return;
            }

            if(!this.steelImage){
                const self = this;

                this.steelImage = document.createElement('img');

                this.steelImage.onload = function(){
                    self.updateMissionScreen();
                };

                switch(this.userInfos.quests){
                    case 0:
                    default:
                        this.steelImage.src= 'assets/img/steel-icon.png';
                    break;
                    case 1:
                        this.steelImage.src= 'assets/img/nitro-icon.png';
                    break;
                    case 2:
                        this.steelImage.src= curEngine.assetBase+'assets/nfts/battery1.png';
                    break;

                    case 4:
                        this.steelImage.src= curEngine.assetBase+'assets/nfts/radar1.png';
                    break;

                    case 6:
                        this.steelImage.src= curEngine.assetBase+'assets/nfts/car_cannon.png';
                    break;

                    case 8:
                        this.steelImage.src= curEngine.assetBase+'assets/nfts/car3.png';
                    break;

                    case 9:
                        this.steelImage.src= curEngine.assetBase+'assets/nfts/car3.png';
                    break;

                }
                
                return;
            }

            this.updateMissionScreen();

            
        }
        

        async updateTrackList(trackclass) {

            const classes = ['C', 'B', 'A'];
            const displayedTracks = [];

            let selected = null;

            for (let i = 0; i < this.tracks.length; i++) {

                if(classes[this.tracks[i].class] === trackclass)
                    displayedTracks.push(this.tracks[i]);
            }

            if(this.firstTrackElement >= displayedTracks.length)
                this.firstTrackElement = 0;


            if(this.firstTrackElement <= -displayedTracks.length)
                this.firstTrackElement = 0;


            let idx = this.firstTrackElement;
            
            for (let i = 0; i < 4; i++) {
                const trackPanel = this.trackPanel[i];

                
                if(trackclass === 'A'){
                    let p = trackPanel.thumb;
                    let ctx = p.ctx;

                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "64px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText("coming soon", 256, 256, 280);
                    this.curEngine.updateTex(p.mesh, p.name);


                    p = trackPanel.bonus;
                    if(p){
                        ctx = p.ctx;
                        ctx.fillStyle = '#' + p.matCol.toString(16);
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                        this.curEngine.updateTex(p.mesh, p.name);
                    }

                    p = trackPanel.time;
                    if(p){
                        ctx = p.ctx;
                        ctx.fillStyle = '#' + p.matCol.toString(16);
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                        this.curEngine.updateTex(p.mesh, p.name);
                    }

                    p = trackPanel.reward;
                    if(p){
                        ctx = p.ctx;

                        ctx.fillStyle = '#' + p.matCol.toString(16);
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                        this.curEngine.updateTex(p.mesh, p.name);
                    }
                    continue;
                }


                if(idx >= displayedTracks.length)
                    idx = 0;

                if(idx < 0)
                    idx += displayedTracks.length;

                let index = idx;
                const track = displayedTracks[index];

                if (!this.trackThumbs[track.name]) {
                    await this.createTrackThumbTex(track);
                }

                if(i === 1)
                    selected = track.name;
                
                if(this.trackThumbs[track.name].img.complete){
                    const p = trackPanel.thumb;
                    if(p){
                        const ctx = p.ctx;
                        ctx.drawImage(this.trackThumbs[track.name].img, 0, 0, p.canvas.width, p.canvas.height);
                        this.curEngine.updateTex(p.mesh, p.name);
                    }
                }else{

                    const self = this;
                    const p1 = trackPanel.thumb;

                    if(p1){
                        const tb1 = self.trackThumbs[track.name];
                        
                        this.trackThumbs[track.name].img.onload = function(){
                            const ctx1 = p1.ctx;
                            ctx1.drawImage(tb1.img, 0, 0, p1.canvas.width, p1.canvas.height);
                            self.curEngine.updateTex(p1.mesh, p1.name);
                        }
                    }
                }

                if(this.trackThumbs[track.name].rimg.complete){
                    const p = trackPanel.reward;

                    if(p){
                        const ctx = p.ctx;

                        ctx.fillStyle = '#' + p.matCol.toString(16);
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                        ctx.drawImage(this.trackThumbs[track.name].rimg, 0, 0, p.canvas.width, p.canvas.height);
                        this.curEngine.updateTex(p.mesh, p.name);
                    }
                }else{

                    const self = this;
                    const p2 = trackPanel.reward;

                    if(p2){
                        const tb2 = self.trackThumbs[track.name];
                    
                        this.trackThumbs[track.name].rimg.onload = function(){
                            const ctx2 = p2.ctx;
                            ctx2.fillStyle = '#' + p2.matCol.toString(16);
                            ctx2.fillRect(0, 0, p2.canvas.width, p2.canvas.height);
        
                            ctx2.drawImage(tb2.rimg, 0, 0, p2.canvas.width, p2.canvas.height);
                            self.curEngine.updateTex(p2.mesh, p2.name);
                        }
                    }
                        
                }


                let p;
                let ctx;
                p = trackPanel.bonus;
                if(p){
                    ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "32px impact";
                    ctx.textAlign = 'left';
                    ctx.fillText(track.nBonus, 16, 44, 280);
                    this.curEngine.updateTex(p.mesh, p.name);
                }

                p = trackPanel.time;
                if(p){
                    ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "32px impact";
                    ctx.textAlign = 'left';
                    ctx.fillText(track.lapTime, 16, 44, 280);
                    this.curEngine.updateTex(p.mesh, p.name);
                }

                p = trackPanel.name;
                if(p){
                    ctx = p.ctx;
                    ctx.fillStyle = '#000000';
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.textAlign = 'center';
                    ctx.fillText(track.name, p.canvas.width / 2, 48, p.canvas.width);
                    this.curEngine.updateTex(p.mesh, p.name);
                }
                idx++;
            }

            if(this.levelThumb)
                this.updateLevel(selected);
        }
        
        updateTrackRanks(track) {

            for (let i = 0; i < 3; i++) {
                const p = this.rankScreens[i];

                if(p){
                    const ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

             

                    ctx.fillStyle = '#000000';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "32px impact";
                    

                    if ((track)&&(track.times) && (i < track.times.length)) {

                        const ac = track.times[i].account.length > 16 ? track.times[i].account.substr(0, 16) + '...' : track.times[i].account;

                        ctx.textAlign = 'left';
                        ctx.fillText(ac, 16, 44, 280);
                        ctx.textAlign = 'center';
                        ctx.fillText(track.times[i].time.toString(), 330, 44, 60);
                        ctx.fillText(track.times[i].nitros.toString(), 390, 44, 60);
                        ctx.fillText(track.times[i].dmg.toString(), 440, 44, 60);
                        ctx.fillText(track.times[i].bonus.toString(), 490, 44, 60);
                    }else{
                        ctx.textAlign = 'center';
                        ctx.fillText('--', 16, 40, 280);
                        ctx.fillText('--', 330, 40, 60);
                        ctx.fillText('--', 390, 40, 60);
                        ctx.fillText('--', 440, 40, 60);
                        ctx.fillText('--', 490, 40, 60);
                    }
                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                }
            }
        }

        getClosestInter(intersectsPt){

            let minDist = null;
            let selObject = null;

            for (let i = 0; i < intersectsPt.length; i++) {

                if((minDist === null)||(minDist < intersectsPt[i].distance)){

                    const oname = intersectsPt[i].object.name;
                    let unsel = false;

                    if (oname.startsWith('panel-')) {
                        const ar = oname.split('-');
                        const panel = ar[1];
                        const name = intersectsPt[i].object.material.name;

                        for (let b of this.buttons) {
                            if ((b.panel === panel) && (b.name === name)&&(b.unselable === true)){
                                unsel=true;
                                break;
                            }
                        }
                    }
                        
                    if(!unsel){
                        selObject= intersectsPt[i];
                        minDist = intersectsPt[i].distance;
                    }
                }
            }
            return selObject;
        }

        setAllCulled(obj, culled) {

            if(culled){
                obj.traverse(function(c){
                    c.oldFC = c.frustumCulled;
                    c.frustumCulled = false;
                })
            }else{
                obj.traverse(function(c){
                    c.frustumCulled = c.oldFC;
                })
            }
        }

        setBlockchainInfos(blockchaininfos) {
            super.setBlockchainInfos(blockchaininfos);

            const ar=blockchaininfos.network.split('-');
            this.selectedNetwork = ar[1];
            this.selectedBlockchain = blockchaininfos.bc_type;

            switch(this.selectedBlockchain){
                case BC_WAX : this.targetWalletBoadAngle = Math.PI;break;
                case BC_SOLANA : this.targetWalletBoadAngle = 0.0;break;
            }

        }
            
    animate() {

        const curEngine = this.curEngine;
        const character = this.character;
        const world = this.world;

        const dt = curEngine.clock.getDelta();
        const tt = curEngine.clock.getElapsedTime();        

        if((this.green_screen_img)&&(this.green_screen_img.complete))
                this.updateAccountTex();

        curEngine.enableRender(true, this.glDomRef);

        if(this.npc1){
            const wnpc = this.npc1;
            if(wnpc.dialog && wnpc.avatarMesh &&  wnpc.bMesh){

                if(this.characterPHY !== null){

                    if(wnpc.ppos.distanceTo(this.characterPHY.tpos)<wnpc.avatarDef.activation ){
                        
                        wnpc.scriptInstance.state = 'wait';
                        wnpc.scriptInstance.time = Infinity;

                        if(this.phys.npcs.length>0)
                            this.phys.npcs[0].anims = [{a : wnpc.avatarDef.talkAnim, t: tt}];

                        const q = new THREE.Quaternion();

                        if(this.renderMode === 0){
                            const bone = wnpc.tskel.getBoneByName('head');
                            bone.quaternion.set(q.x,q.y,q.z,q.w);

                            const bone2 = wnpc.tskel.getBoneByName('spine');
                            bone2.quaternion.set(q.x,q.y,q.z,q.w);
                        }                        
                    
                        if(wnpc.dialog){

                            if(wnpc.dialogOptions === null){
                                if(wnpc.selectedAnswer<127)
                                    this.curEngine.OpenDialog(wnpc);
                            }else{
                                if(wnpc.selectedAnswer==127)
                                    this.curEngine.removeDialog(wnpc);
                            }
                        }

                    }else if(wnpc.ppos.distanceTo(this.characterPHY.tpos)<wnpc.avatarDef.activation * 2.0 ){

                        const q = wnpc.avatarMesh.quaternion.clone();
                        const m = new THREE.Matrix4();
                        const mt = new THREE.Vector3(), mq= new THREE.Quaternion(), ms= new THREE.Vector3();

                        const lp = new THREE.Vector3(this.character.ppos.x, wnpc.avatarMesh.position.y, this.character.ppos.z)

                        m.lookAt( wnpc.avatarMesh.position, lp,   new THREE.Vector3(0, 1, 0));
                        m.decompose(mt, mq, ms);
                        mq.multiply(q.conjugate());

                        const mq2 = new THREE.Quaternion(mq.x, mq.y, mq.z, mq.w/2.0).normalize();
                        mq2.multiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(0, Math.PI, 0)))

                        if((this.phys.npcs.length >= 1)&&(this.phys.npcs[0].anims[0] !== wnpc.avatarDef.waveAnim)&&(this.phys.npcs[0].anims[1] !== wnpc.avatarDef.waveAnim))
                            this.phys.npcs[0].anims.push({a : wnpc.avatarDef.waveAnim, t : tt, e : tt + wnpc.anims[wnpc.avatarDef.waveAnim].endTime});
                        
                        if(this.renderMode === 0){
                            const bone = wnpc.tskel.getBoneByName('head');
                            bone.quaternion.set(mq2.x,mq2.y,mq2.z,mq2.w);

                            const bone2 = wnpc.tskel.getBoneByName('spine');
                            bone2.quaternion.set(mq2.x,mq2.y,mq2.z,mq2.w);
                        }
                    }else{
                        if(wnpc.dialogOptions !== null){
                            this.curEngine.removeDialog(wnpc);
                        }

                        if(wnpc.scriptInstance.state !== 'move'){

                            if(this.phys.npcs.length>0)
                                this.phys.npcs[0].anims = [{a : wnpc.avatarDef.walkAnim, t: tt}];

                            wnpc.scriptInstance.state = 'move';

                            const q = new THREE.Quaternion();

                            if(this.renderMode === 0){
                                const bone = wnpc.tskel.getBoneByName('head');
                                bone.quaternion.set(q.x,q.y,q.z,q.w);

                                const bone2 = wnpc.tskel.getBoneByName('spine');
                                bone2.quaternion.set(q.x,q.y,q.z,q.w);
                            }
                        }
                    }

                    //wnpc.setDialogLine(this.dialogLine, this.dialogSubLine)

                    if(wnpc.dialogOptions){
                        wnpc.dialogOptions.lookAt(this.curEngine.cameraAnchor.position);

                        for(let answer of wnpc.dialogAnswers){
                            answer.back.updateMatrix(true);
                            answer.back.updateWorldMatrix(true);
                            answer.selectMesh.matrix.copy(answer.back.matrixWorld)
                            answer.selectMesh.updateWorldMatrix(true);
                        }
                    }

                }
            }
        
        }
    
        if (!curEngine.isVr){
            if(this.glDomRef.current)
                curEngine.resizeCanvasToDisplaySize(this.glDomRef.current.offsetWidth, this.glDomRef.current.offsetHeight);
        }
            

        const q1 = new THREE.Quaternion().setFromEuler(new THREE.Euler(this.camVAngle, 0, 0, "XYZ"));
        const q = character.prot.clone().multiply(q1);

        curEngine.cameraAnchor.position.x = character.ppos.x;
        curEngine.cameraAnchor.position.y = character.ppos.y;
        curEngine.cameraAnchor.position.z = character.ppos.z;
        curEngine.cameraAnchor.quaternion.x = q.x;
        curEngine.cameraAnchor.quaternion.y = q.y;
        curEngine.cameraAnchor.quaternion.z = q.z;
        curEngine.cameraAnchor.quaternion.w = q.w;

        curEngine.cameraAnchor.updateWorldMatrix();
        curEngine.camera.updateWorldMatrix();

        if (curEngine.isVr) {

            const session = curEngine.renderer.xr.getSession();
            if (session) {
                curEngine.initXRControllers(session);
            }

            if (curEngine.controller1) {

                curEngine.vrRay1.matrixAutoUpdate = false;

                const p = curEngine.controller1.position.clone().applyQuaternion(curEngine.cameraAnchor.quaternion).add(curEngine.cameraAnchor.position);
                curEngine.vrRay1.position.set(p.x, p.y, p.z);
                curEngine.vrRay1.quaternion.set(curEngine.controller1.quaternion.x, curEngine.controller1.quaternion.y, curEngine.controller1.quaternion.z, curEngine.controller1.quaternion.w);
                curEngine.vrRay1.quaternion.premultiply(curEngine.cameraAnchor.quaternion);
                curEngine.vrRay1.updateMatrix(true);
                curEngine.vrRay1.updateMatrixWorld(true);

                curEngine.vrTeleport1.visible = false;

                const intersectsPt = [];
                const forward = new THREE.Vector3(0, 0, -1).applyQuaternion(curEngine.vrRay1.quaternion);
                raycaster.set(curEngine.vrRay1.position, forward);

                if(this.dialogOptions !== null)
                    raycaster.intersectObjects(this.dialogOptions.children, false, intersectsPt);
                else
                    raycaster.intersectObjects(curEngine.selectScene.children, false, intersectsPt);

                curEngine.controller2.hover = {};

                if (intersectsPt.length > 0) {
                    
                    this.processPointer(intersectsPt, curEngine.controller2.hover);

                    curEngine.vrTeleport1.canTeleport = false;
                    curEngine.vrTeleport1.material.color.setRGB(0.0, 1.0, 0.0);

                }else {
                    raycaster.intersectObject(this.floor, false, intersectsPt);

                    const selObject = this.getClosestInter(intersectsPt);

                    if(selObject){
                        const oname = selObject.object.name;

                        if (oname === 'floor') {
                            curEngine.vrTeleport1.visible = true;
                            curEngine.vrTeleport1.position.set(selObject.point.x, selObject.point.y, selObject.point.z);

                            const rayBox = new THREE.Box3( new THREE.Vector3(curEngine.vrTeleport1.position.x - character.avatarDef.radius, -5, curEngine.vrTeleport1.position.z - character.avatarDef.radius),
                                                            new THREE.Vector3(curEngine.vrTeleport1.position.x + character.avatarDef.radius,  5, curEngine.vrTeleport1.position.z + character.avatarDef.radius));

                            let col = false;
                            for(let c of world.track.cubes){

                                if(c.name.startsWith('floor'))
                                    continue;

                                if(c.box.intersectsBox  (rayBox))
                                    col = true;
                            }

                            if(col){
                                curEngine.vrTeleport1.canTeleport = false;
                                curEngine.vrTeleport1.material.color.setRGB(1.0, 0.0, 0.0);
                            } else{
                                curEngine.vrTeleport1.canTeleport = true;
                                curEngine.vrTeleport1.material.color.setRGB(1.0, 1.0, 1.0);
                            }
                        }
                    }
                }
            }


            if (curEngine.controller2) {

                curEngine.vrRay2.matrixAutoUpdate = false;

                const p = curEngine.controller2.position.clone().applyQuaternion(curEngine.cameraAnchor.quaternion).add(curEngine.cameraAnchor.position);;

                curEngine.vrRay2.position.set(p.x, p.y, p.z);
                curEngine.vrRay2.quaternion.set(curEngine.controller2.quaternion.x, curEngine.controller2.quaternion.y, curEngine.controller2.quaternion.z, curEngine.controller2.quaternion.w);
                curEngine.vrRay2.quaternion.premultiply(curEngine.cameraAnchor.quaternion);
                curEngine.vrRay2.updateMatrix(true);
                curEngine.vrRay2.updateMatrixWorld(true);

                curEngine.vrTeleport2.visible = false;

                const intersectsPt = [];
                const forward = new THREE.Vector3(0, 0, -1).applyQuaternion(curEngine.vrRay2.quaternion);
                raycaster.set(curEngine.vrRay2.position, forward);

                if(this.dialogOptions !== null)
                    raycaster.intersectObjects(this.dialogOptions.children, false, intersectsPt);
                else
                    raycaster.intersectObjects(curEngine.selectScene.children, false, intersectsPt);

                curEngine.controller2.hover = {};

                if (intersectsPt.length > 0) {
                    this.processPointer(intersectsPt, curEngine.controller2.hover);

                    curEngine.vrTeleport2.canTeleport = false;
                    curEngine.vrTeleport2.material.color.setRGB(0.0, 1.0, 0.0);

                }else {
                    raycaster.intersectObject(this.floor, false, intersectsPt);
                    const selObject = this.getClosestInter(intersectsPt);

                    if(selObject){

                        for (let i = 0; i < intersectsPt.length; i++) {
                            const oname = selObject.object.name;
                            if (oname === 'floor') {
                                curEngine.vrTeleport2.visible = true;
                                curEngine.vrTeleport2.position.set(selObject.point.x, selObject.point.y, selObject.point.z);

                                const rayBox = new THREE.Box3(  new THREE.Vector3(curEngine.vrTeleport2.position.x - character.avatarDef.radius, -5, curEngine.vrTeleport2.position.z - character.avatarDef.radius),
                                                                new THREE.Vector3(curEngine.vrTeleport2.position.x + character.avatarDef.radius,  5, curEngine.vrTeleport2.position.z + character.avatarDef.radius));

                                let col = false;
                                for(let c of world.track.cubes){

                                    if(c.name.startsWith('floor'))
                                        continue;

                                    if(c.box.intersectsBox (rayBox))
                                        col = true;
                                }

                                if(col){
                                    curEngine.vrTeleport2.canTeleport = false;
                                    curEngine.vrTeleport2.material.color.setRGB(1.0, 0.0, 0.0);
                                }
                                else{
                                    curEngine.vrTeleport2.canTeleport = true;
                                    curEngine.vrTeleport2.material.color.setRGB(1.0, 1.0, 1.0);
                                }
                                    
                            }
                        }
                    }
                }
            }
        }

        const t = new Transformation3();

        if (this.isLoading) {

            this.loadingController.txt.rotation.y = tt;

            t.set(this.loadingController.txt.position, this.loadingController.txt.quaternion);
            curEngine.updateTransform(this.loadingController.txt, t )

            curEngine.updateSprite(this.loadingController.loading1);
            curEngine.updateSprite(this.loadingController.loading2);
        }


        if(this.trackMoving){

            const now  = new Date().getTime();
            const dt = (now - this.trackMoveStart) / 1000.0;

            if(this.trackMovingDir > 0 ){
                this.trackList.rotation.y += dt * 0.1;

                if( this.trackList.rotation.y >= (Math.PI / 2+this.trackListOAngle.y)){
                    this.trackMoving = false;

                    if(this.gameMode === 'new'){
                        this.firstTrackElement++;
                        this.updateTrackList(this.currentTrackClass);
                    }else{
                        this.firstGameElement++;
                        this.updateGameList(this.currentTrackClass);
                    }
                    this.trackList.rotation.y = this.trackListOAngle.y;

                }
            }else{

                this.trackList.rotation.y -= dt * 0.1;

                if( this.trackList.rotation.y <= (-Math.PI / 2 + this.trackListOAngle.y)){
                    this.trackMoving = false;

                    if(this.gameMode === 'new'){
                        this.firstTrackElement--;
                        this.updateTrackList(this.currentTrackClass);
                    }else{
                        this.firstGameElement--;
                        this.updateGameList(this.currentTrackClass);

                    }
                    this.trackList.rotation.y = this.trackListOAngle.y;
                }
            }

            this.trackList.updateMatrixWorld();
            t.set(this.trackList.position, this.trackList.quaternion);
            this.curEngine.updateTransform( this.trackList, t);

        }

        const padEvents = curEngine.updatePadsStatus();

        for(let w of this.wires){
            curEngine.setTextureOffset(w, 'wiire', tt);
        }

        for(let r of this.ringObjects){
            const  e = (Math.sin(tt * 2.0) + 1.0) * 0.5;

            curEngine.setEmission(r, 'inner', 0, e * 0.5 + 0.25, e * 0.5 + 0.25);
            curEngine.setLightIntensity(r.rectLight, e + 0.5);
        }

        for(let n =0; n< this.world.track.cyls.length;n++){
            const c = this.world.track.cyls[n];
            if(c.mesh){
                c.mesh.position.set(c.pos.x, c.pos.y, c.pos.z);
                c.mesh.quaternion.set(c.rot.x, c.rot.y, c.rot.z, c.rot.w);

                t.set(c.mesh.position, c.mesh.quaternion);
                this.curEngine.updateTransform(c.mesh, t);
            }
        }

        if((this.currentLevel)&&(this.trackThumbs[this.currentLevel].road)){
            this.trackThumbs[this.currentLevel].road.rotation.y = tt;
            t.set(this.trackThumbs[this.currentLevel].road.position, this.trackThumbs[this.currentLevel].road.quaternion);
            this.curEngine.updateTransform(this.trackThumbs[this.currentLevel].road, t);
        }


        if(this.walletBoard){

            if(this.walletBoard.rotation.y<this.targetWalletBoadAngle){
                this.walletBoard.rotation.y = Math.min(this.targetWalletBoadAngle, this.walletBoard.rotation.y+ 2.0 * dt);

                this.walletBoard.updateMatrix();
                this.walletBoard.updateMatrixWorld();

                const selecteds = curEngine.selectScene.getObjectsByProperty('name', this.walletBoard.name);

                for(let selected of selecteds){
                    selected.rotation.copy(this.walletBoard.rotation);
                    selected.matrix.copy(this.walletBoard.matrix);
                    selected.matrixWorld.copy(this.walletBoard.matrixWorld);
                }
                

            }else if(this.walletBoard.rotation.y>this.targetWalletBoadAngle){
                this.walletBoard.rotation.y = Math.max(this.targetWalletBoadAngle, this.walletBoard.rotation.y- 2.0 * dt);

                this.walletBoard.updateMatrix();
                this.walletBoard.updateMatrixWorld();

                const selecteds = curEngine.selectScene.getObjectsByProperty('name', this.walletBoard.name);

                for(let selected of selecteds){
                    selected.position.copy(this.walletBoard.position);
                    selected.rotation.copy(this.walletBoard.rotation);
                    selected.matrix.copy(this.walletBoard.matrix);
                    selected.matrixWorld.copy(this.walletBoard.matrixWorld);
                }
            }

            this.walletBoard.updateMatrixWorld(true)
            curEngine.updateTransform(this.walletBoard, new Transformation3(this.walletBoard.position, this.walletBoard.quaternion))
        }

          if(world.track){

            for (let n = 0; n < world.track.npcs.length; n++) {

                const wchar = this.world.track.npcs[n];

                if(wchar.selectMesh){
                    wchar.selectMesh.position.set(wchar.ppos.x, wchar.ppos.y + wchar.worldOffset.y, wchar.ppos.z);
                    wchar.selectMesh.quaternion.set(wchar.prot.x, wchar.prot.y, wchar.prot.z, wchar.prot.w);
                    wchar.selectMesh.updateMatrixWorld();
                }

                if((n +1) > this.phys.npcs.length)
                    continue;

                const char = this.phys.npcs[n];
                
                
                wchar.avatarMesh.position.set(wchar.ppos.x, wchar.ppos.y + wchar.worldOffset.y, wchar.ppos.z);
                wchar.avatarMesh.quaternion.set(wchar.prot.x, wchar.prot.y, wchar.prot.z, wchar.prot.w);

                t.set(wchar.avatarMesh.position, wchar.avatarMesh.quaternion);

                curEngine.updateTransform(wchar.avatarMesh, t, 0);
        
                if(wchar.avatarDef.ragdoll === true)
                    continue;

                for(let a of char.anims){
                    const at = tt - a.t;
                    curEngine.applyAnimation(wchar, wchar.anims[a.a], at);
                }
            }
        }

        for(let gev of padEvents){

            const characterPHY = this.characterPHY;
            const character = this.character;

            if(gev.xr) {

                if(gev.idx == 0) {
                    if (gev.axis === 2) {
                        if(curEngine.XRPads[gev.idx].axes[gev.axis]<-0.5){
                            characterPHY.actions['left'].state = 1;
                            characterPHY.actions['right'].state = 0;
                        }else if(curEngine.XRPads[gev.idx].axes[gev.axis]>0.5){
                            characterPHY.actions['right'].state = 1;
                            characterPHY.actions['left'].state = 0;
                        }else{
                            characterPHY.actions['right'].state = 0;
                            characterPHY.actions['left'].state = 0;
                            const zv = new THREE.Vector3();
                            this.phys.movePhyChar(character.id, zv);
                        }
                    }
                }

                if(gev.idx == 1){

                    if (gev.axis === 2) {

                        if(curEngine.XRPads[gev.idx].axes[gev.axis]<-0.5){
                            this.phys.rotatePhyChar(this.character.id, Math.PI / 8.0);
                        }
    
                        if(curEngine.XRPads[gev.idx].axes[gev.axis]>0.5){
                            this.phys.rotatePhyChar(this.character.id, -Math.PI / 8.0);
                        }
                    }
                }

                if (gev.axis === 3) {
    
                    if(curEngine.XRPads[gev.idx].axes[gev.axis]<-0.5){
                        characterPHY.actions['forward'].state = 1;
                        characterPHY.actions['backward'].state = 0;
                    }else if(curEngine.XRPads[gev.idx].axes[gev.axis]>0.5){
                        characterPHY.actions['backward'].state = 1;
                        characterPHY.actions['forward'].state = 0;
                    }else{
                        characterPHY.actions['forward'].state = 0;
                        characterPHY.actions['backward'].state = 0;
                        const zv = new THREE.Vector3();
                        this.phys.movePhyChar(character.id, zv);
                    }
                }
            }
        }
    
        if (this.podcar) {
            this.podcar.rotation.y = tt;
            t.set(this.podcar.position, this.podcar.quaternion);
            this.curEngine.updateTransform(this.podcar , t);
        }

        for (let o of this.movingObjects) {
            o.rotation.y = tt;
            t.set(o.position, o .quaternion);
            this.curEngine.updateTransform(o , t);
        }

        curEngine.lastTime = tt;

        if(this.world.track.terrain){
            for(let l =0;l<this.world.track.terrain.lights.length; l++){
                this.world.track.terrain.lights[l].light.intensity = (Math.sin(l * Math.PI + tt) +1) * 0.5 + 0.3;
            }

            if(this.baseEmmMat){
                this.baseEmmMat.emissiveIntensity = (Math.sin(tt) +1.0) * 4.0 + 0.5;
            }

            const spd = 0.3;
            
            for(let o of world.track.terrain.movingTerrain) {

                if (o.name.startsWith('WheelL')) {
                    o.rotation.z = -spd * tt;
                }else if (o.name.startsWith('WheelR')) {
                    o.rotation.z = -spd * tt;
                }else if (o.name.startsWith('WheelT')) {
                    o.rotation.x = -spd * tt;
                }else if (o.name.startsWith('WheelA')) {
                    o.rotation.x = +spd * tt;
                }else if (o.name.startsWith('WheelF')) {
                    o.rotation.y = -spd * tt;
                }else if (o.name.startsWith('WheelB')) {
                    o.rotation.y = spd * tt;

                } 
                t.set(o.position, o.quaternion);
                curEngine.updateTransform(o, t)
            }
        }

        if (this.phys){

            if((this.spider)&&(this.spider.skel)){
                this.spider.inContact = false;
                this.phys.resetskelContact(this.spider.skel.root);
            }
            this.phys.updatePhysicsUniverse(this.world, frameTime / 1000.0, tt);    
                        
            if((this.zombie)&&(this.zombie.skeleton)&&(this.zombie.tskel)){
                //this.curEngine.updateRagDoll(this.zombie);
                this.curEngine.interpolateRagDoll(this.zombie.tskel, this.zombie.skeleton.root, null);
            }
            
            if((this.spider)&&(this.spider.skel)){
                this.phys.animateSpider(this.spider.skel, tt);
                this.phys.findSkelnewContact(this.spider.skel.root);
                this.curEngine.updateSpiderSkel(this.spider.skel);
            }
        }

        if (this.map) {
            for (let levelName in this.map.levels) {

                this.map.levels[levelName].road.rotation.y = tt;
            }
        }


        if((this.renderMode === 0)&&(this.firstFrame == true)) {
            this.setAllCulled(curEngine.scene, true);
        }
        
        if((curEngine.useMobileUI)&&(this.gameControls)){
            curEngine.updateSprite(this.gameControls.accel);
            curEngine.updateSprite(this.gameControls.brake);
        }

        curEngine.render(dt);

        if((this.renderMode === 0)&&(this.firstFrame == true)) {
            this.setAllCulled(curEngine.scene, false);
        }

        this.firstFrame = false;

        if(this.curEngine.rtEngine)
            this.curEngine.rtEngine.update();

        if(this.renderMode == 2)
            this.animReq = requestAnimationFrame(this.animateFunc);
    }

    onKey(e) {

        const curEngine = this.curEngine;
        const characterPHY = this.characterPHY;

        if(e.key === 'l'){
            curEngine.camLight = curEngine.camLight ? false : true;
        }
        
        if(e.code === 'KeyC'){
            console.log(JSON.stringify(this.curEngine.cameraAnchor.position));
            console.log(JSON.stringify(this.curEngine.cameraAnchor.quaternion));
        }

        if(e.code === 'KeyX'){
            this.phys.killSpider(this.spider.skel);
        }
        
        if (keysActions[e.code]) {

            if (keysActions[e.code] === 'acceleration') {

                if (!pressed[e.code]) {
                    characterPHY.actions['forward'].state = 1;
                    pressed[e.code] = true;
                }

                if (pressed['braking']) {
                    characterPHY.actions['backward'].state = 0;
                }
            }

            if (keysActions[e.code] === 'braking') {

                if (!pressed[e.code]) {
                    characterPHY.actions['backward'].state = 1;
                    pressed[e.code] = true;
                }

                if (pressed['acceleration']) {
                    characterPHY.actions['forward'].state = 0;
                }
            }

            if (keysActions[e.code] === 'left') {

                if (!pressed[e.code]) {
                    characterPHY.actions['left'].state = 1;
                    pressed[e.code] = true;
                }

                if (pressed['right']) {
                    characterPHY.actions['right'].state = 0;
                }
            }

            if (keysActions[e.code] === 'right') {
                if (!pressed[e.code]) {
                    characterPHY.actions['right'].state = 1;
                    pressed[e.code] = true;
                }
                if (pressed['left']) {
                    characterPHY.actions['left'].state = 0;
                }
            }
        }

    }

    unKey(e) {
        const characterPHY = this.characterPHY;

        if (keysActions[e.code] === 'acceleration') {

            if (pressed[e.code]) {
                characterPHY.actions['forward'].state = 0;
                pressed[e.code] = false;
            }

            if (pressed['braking']) {
                characterPHY.actions['backward'].state = 1;
            }
        }

        if (keysActions[e.code] === 'braking') {

            if (pressed[e.code]) {
                characterPHY.actions['backward'].state = 0;
                pressed[e.code] = false;
            }

            if (pressed['acceleration']) {
                characterPHY.actions['forward'].state = 1;
            }
        }

        if (keysActions[e.code] === 'left') {

            if (pressed[e.code]) {
                characterPHY.actions['left'].state = 0;
                pressed[e.code] = false;
            }

            if (pressed['right']) {
                characterPHY.actions['right'].state = 1;
            }
        }

        if (keysActions[e.code] === 'right') {

            if (pressed[e.code]) {
                characterPHY.actions['right'].state = 0;
                pressed[e.code] = false;
            }

            if (pressed['left']) {
                characterPHY.actions['left'].state = 1;
            }
        }

        if ((characterPHY.actions['right'].state == 0) &&
            (characterPHY.actions['left'].state == 0) &&
            (characterPHY.actions['forward'].state == 0) &&
            (characterPHY.actions['backward'].state == 0)) {

            const zv = new THREE.Vector3();
            this.phys.movePhyChar(characterPHY.id, zv);
        }
    }

    doAccel() {

        const acl = this.curEngine.sensor.quaternion;

        const eul = new THREE.Euler().setFromQuaternion(new THREE.Quaternion(acl[0], acl[1], acl[2], acl[3]));

        const curX = (eul.x * 2.0 + Math.PI);
        const curY = eul.y * 2.0;

        if (lastEul != null) {
            const deltaEulX = lastEul.x - curX;
            const deltaEulY = lastEul.y - curY;

            if (Math.abs(deltaEulX) > 0.001)
                this.camVAngle -= deltaEulY;

            if (Math.abs(deltaEulY) > 0.001)
                this.phys.rotatePhyChar(this.character.id, +deltaEulX)
        }

        lastEul = { x: curX, y: curY };
    }

    initSensorEvents() {
        
        if(this.curEngine.sensor === null)
            return;
        
        this.curEngine.sensor.onreading = () => this.doAccel();
        this.curEngine.sensor.onerror = (event) => {
            if (event.error.name == 'NotReadableError') {
                console.log("Sensor is not available.");
            }
        }
        this.curEngine.sensor.start();
    }
    
    onTouch(e) {

        const curEngine = this.curEngine;
        e = e || window.event;

        let rect = e.target.getBoundingClientRect();

        const width = this.glDomRef.current.offsetWidth;
        const height = this.glDomRef.current.offsetHeight;

        for (let touch of e.changedTouches) {

            pointer.x = ((touch.clientX - rect.left) / width) * 2 - 1;
            pointer.y = - ((touch.clientY - rect.top) / height) * 2 + 1;
            const t = {
                id: touch.id,
                curX: (touch.clientX - rect.left) / width,
                curY: (touch.clientY - rect.top) / height,
                lastX: (touch.clientX - rect.left) / width,
                lastY: (touch.clientY - rect.top) / height
            };

            const hit = curEngine.checkUIButtons(this.gameControls, pointer.x * 100, pointer.y * 100);
            if (hit) {

                if (hit.name === 'accel') {

                    if (!clickedUI['accel']) {
                        this.characterPHY.actions['forward'].state = 1;
                        clickedUI['accel'] = true;
                    }

                    if (clickedUI['brake']) {
                        this.characterPHY.actions['backward'].state = 0;
                    }
                }

                if (hit.name === 'brake') {

                    if (!clickedUI['brake']) {
                        this.characterPHY.actions['backward'].state = 1;
                        clickedUI['brake'] = true;
                    }

                    if (clickedUI['accel']) {
                        this.characterPHY.actions['forward'].state = 0;
                    }
                }

                t.isUI = true;
            } else {
                const intersectsPt =  [];
                raycaster.setFromCamera(pointer, curEngine.camera);
                raycaster.intersectObjects(curEngine.selectScene.children, true, intersectsPt);
                this.processPointer(intersectsPt, this.hover);
                t.isUI = intersectsPt.length >0 ? true : false;
            }


            touches.push(t);
        }
    }

    touchMove(e) {

        let rect = e.target.getBoundingClientRect();

        const width = this.glDomRef.current.offsetWidth;
        const height = this.glDomRef.current.offsetHeight;

        for (let touch of e.changedTouches) {

            for (let t of touches) {

                if ((t.id == touch.id)&&(t.isUI === false)) {

                    let curX = (touch.clientX - rect.left) / width;
                    let curY = (touch.clientY - rect.top) / height;

                    this.phys.rotatePhyChar(this.character.id, (t.lastX - curX) * 1.5);

                    this.camVAngle += (t.lastY - curY)* 0.5;

                    this.camVAngle= Math.max(this.camVAngle, -Math.PI/2);
                    this.camVAngle= Math.min(this.camVAngle, Math.PI/2);

                    t.lastX = curX;
                    t.lastY = curY;
                }
            }
        }

        if (e.preventDefault)
            e.preventDefault();
        else
            e.returnValue = false;
    }


    touchEnd(e) {

        for (let touch of e.changedTouches) {

            for (let n = 0; n < touches.length; n++) {

                if (touches[n].id == touch.id) {


                    if (clickedUI['brake']) {
                        this.characterPHY.actions['backward'].state = 0;
                        clickedUI['brake'] = false;

                    }

                    if (clickedUI['accel']) {
                        this.characterPHY.actions['forward'].state = 0;
                        clickedUI['accel'] = false;
                    }

                    if ((this.characterPHY.actions['right'].state == 0) &&
                        (this.characterPHY.actions['left'].state == 0) &&
                        (this.characterPHY.actions['forward'].state == 0) &&
                        (this.characterPHY.actions['backward'].state == 0)) {

                        const zv = new THREE.Vector3();
                        this.phys.movePhyChar(this.characterPHY.id, zv);
                    }

                    touches.splice(n, 1);
                    break;
                }
            }
        }

        if (touches.length <= 0) {
            document.querySelector('#gl-dom').removeEventListener('touchend', this.touchEndFunc);
            document.querySelector('#gl-dom').removeEventListener('touchmove', this.touchMoveFunc);
        }
    }
    
   
    onClick(e) {

        const curEngine = this.curEngine;

        e = e || window.event;

        let rect = e.target.getBoundingClientRect();

        const width = this.glDomRef.current.offsetWidth;
        const height = this.glDomRef.current.offsetHeight;

        pointer.x = ((e.clientX - rect.left) / width) * 2 - 1;
        pointer.y = - ((e.clientY - rect.top) / height) * 2 + 1;

        const hit = curEngine.checkUIButtons(this.gameControls, pointer.x * 100, pointer.y * 100);
        if (hit) {

            if (hit.name === 'accel') {

                if (!clickedUI['accel']) {
                    this.characterPHY.actions['forward'].state = 1;
                    clickedUI['accel'] = true;
                }

                if (clickedUI['brake']) {
                    this.characterPHY.actions['backward'].state = 0;
                }
            }

            if (hit.name === 'brake') {

                if (!clickedUI['brake']) {
                    this.characterPHY.actions['backward'].state = 1;
                    clickedUI['brake'] = true;
                }

                if (clickedUI['accel']) {
                    this.characterPHY.actions['forward'].state = 0;
                }
            }


            if (e.preventDefault)
                e.preventDefault();
            else
                e.returnValue = false;

            return false;
        }

        lastX = (e.clientX - rect.left) / width;
        lastY = (e.clientY - rect.top) / height;
        clicked = true;

        if (this.hover.HoverButton != null) {
            this.selectPanelButton(this.hover.HoverButton.panel, this.hover.HoverButton.name, this.hover.HoverButton.group);
        }

        if(this.hover.HoveredAnswser !== null){

            if( (typeof this.npc1.dialog.lines[this.dialogLine].txt !== 'string' )&&
                ((this.dialogSubLine +1) < this.npc1.dialog.lines[this.dialogLine].txt.length)){
                this.dialogSubLine++;
            }else if(this.npc1.dialogAnswers[this.hover.HoveredAnswser].id>=0){
                this.dialogLine = this.npc1.dialogAnswers[this.hover.HoveredAnswser].id;
                this.dialogSubLine = 0;
            }
            this.curEngine.setDialogLine(this.npc1, this.dialogLine, this.dialogSubLine)
        }

    }

    onPointerMove(e) {
        const curEngine = this.curEngine;

        e = e || window.event;
        let dist = null;

        let rect = e.target.getBoundingClientRect();

        const width = this.glDomRef.current.offsetWidth;
        const height = this.glDomRef.current.offsetHeight;


        pointer.x = ((e.clientX - rect.left) / width) * 2 - 1;
        pointer.y = - ((e.clientY - rect.top) / height) * 2 + 1;

        let curX = (e.clientX - rect.left) / width;
        let curY = (e.clientY - rect.top) / height;

        if (clicked) {

            this.phys.rotatePhyChar(this.character.id, (lastX - curX) * 3.0);

            this.camVAngle += (lastY - curY);

            this.camVAngle= Math.max(this.camVAngle, -Math.PI/2);
            this.camVAngle= Math.min(this.camVAngle, Math.PI/2);

            lastX = curX;
            lastY = curY;
        }

        const intersectsPt = [];
        raycaster.setFromCamera(pointer, curEngine.camera);
        raycaster.intersectObjects(curEngine.selectScene.children, true, intersectsPt);
        this.processPointer(intersectsPt, this.hover);
    }

    resetCharActions(){

        const characterPHY = this.characterPHY;

        if (clickedUI['brake']) {
            characterPHY.actions['backward'].state = 0;
            clickedUI['brake'] = false;

        }

        if (clickedUI['accel']) {
            characterPHY.actions['forward'].state = 0;
            clickedUI['accel'] = false;
        }

        if ((characterPHY.actions['right'].state == 0) &&
            (characterPHY.actions['left'].state == 0) &&
            (characterPHY.actions['forward'].state == 0) &&
            (characterPHY.actions['backward'].state == 0)) {

            const zv = new THREE.Vector3();
            this.phys.movePhyChar(characterPHY.id, zv);
        }

        clicked = false;

    }

    onMouseOut(e){

        this.resetCharActions();
    }

    unClick(e) {
        
        if (this.hover.HoveredChar != null) {

            for(let nc =0; nc < this.world.track.npcs.length; nc++) {

                if(this.world.track.npcs[nc].id === this.hover.HoveredChar) {

                    if(this.world.track.npcs[nc].pos.distanceTo(this.character.ppos)>=this.world.track.npcs[nc].avatarDef.activation)
                        continue;

                    if(this.world.track.npcs[nc].dialog)
                        this.curEngine.OpenDialog(this.world.track.npcs[nc]);
                }
            }
        }

        this.resetCharActions();
    }

    processPointer(intersectsPt, hover) {

        this.hitLevel = null;

        if(this.dialogOptions){

            for(let o of this.dialogOptions.children)
            {
                if(o.material.name === 'dlgback')
                    this.curEngine.setColor(o, o.material.name, 0.125, 0.125, 0.125);

                if(o.material.name === 'dlgtxt')
                    this.curEngine.setColor(o, o.material.name, 0.5, 0.5, 0.5);

            }
        }
        
        for (let b of this.buttons) {

            if (!b.name.endsWith('-cont'))
                this.setButtonState(b, b.disabled === true ? 2 : b.selected ? 1 : 0);
        }

        hover.HoverButton = null;
        hover.HoveredAnswser = null;
        hover.HoveredChar = null;
        hover.HoveredCloseDialog = null;

        let message = this.infoMessage;
        let minDist = null;
        let selObject = null;

        for (let i = 0; i < intersectsPt.length; i++) {

            if(intersectsPt[i].distance > 10)
                continue;

            if((minDist === null)||(minDist < intersectsPt[i].distance)){

                const oname = intersectsPt[i].object.name;
                let unsel = false;

                if (oname.startsWith('panel-')) {
                    const ar = oname.split('-');
                    const panel = ar[1];
                    const name = intersectsPt[i].object.material.name;

                    for (let b of this.buttons) {
                        if ((b.panel === panel) && (b.name === name)&&(b.unselable === true)){
                            unsel=true;
                            break;
                        }
                    }
                }
                    
                if(!unsel){
                    selObject = intersectsPt[i];
                    minDist = intersectsPt[i].distance;
                }
            }
        }

        if(selObject){

            const oname = selObject.object.name;

            if (oname.startsWith('select-answer-')) {
                hover.HoveredAnswser = parseInt(oname.substr(14));
            }
            if (oname == 'select-next-line') {
                hover.HoveredAnswser = 0;
            }
            if (oname.startsWith('select-end-dialog-')) {
                const id = parseInt(oname.substr(18));
                hover.HoveredCloseDialog = 1;
            }
            
            if (oname.startsWith('npc-')) {

                const id = parseInt(oname.substr(4));

                for(let nc =0; nc < this.world.track.npcs.length; nc++){
                    if(this.world.track.npcs[nc].id === id){
                        hover.HoveredChar = id;
                    }
                }
            }

            if (oname.startsWith('panel-')) {
                const ar = oname.split('-');
                const panel = ar[1];
                const name = selObject.object.material.name;

                for (let b of this.buttons) {

                    if(b.unselable === true)
                        continue;

                    if ((b.panel === panel) && (b.name === name)) {

                        if (b.disabled === true) {

                            if ((panel === 'gametype') && (name.startsWith('gametype-join'))) {
                                message = 'free car or NFT only';
                            }

                            if ((panel === 'racetype') && (name.startsWith('racetype-pro'))) {
                                message = 'free car or NFT only';
                            }

                            if ((panel === 'racetype') && (name.startsWith('racetype-pvp'))) {
                                message = 'NFT car only';
                            }
                            continue;
                        }

                        if (b.panel === 'car') {

                            if ((b.name === 'screen-carthumb')) {
                                this.updateCarStats('car');
                            }

                            if ((b.name === 'screen-tirethumb')) {
                                this.updateCarStats('tire');
                            }

                            if ((b.name === 'screen-enginethumb')) {
                                this.updateCarStats('motor');
                            }
                        }

                        this.setButtonState(b, 1);
                        hover.HoverButton = b;
                    }
                }
            }
        }

        if(hover.HoveredAnswser !== null)
            this.curEngine.setDialogAnswer(this.npc1, hover.HoveredAnswser);
        else
            this.curEngine.setDialogAnswer(this.npc1, -1);

        this.updateInfoBlock(message);
    }

        updateCoinIcon() {

            if(!this.coinIcon)
                return;
            const tex = this.blockchaininfos.network.startsWith('wax') ? this.waxIconTex : this.solanaIconTex;
            this.curEngine.setTex(this.coinIcon.o,this.coinIcon.m.name, tex);
        }
        
        updateAccountTex( ) {

            
            const steels = this.userBalance ? this.userBalance.stl: '-';
            const balance = this.userBalance ? this.userBalance.main: '-';

            for (let p of this.panels) {

                if (p.name === 'account') {

                    const ctx = p.ctx;
                    
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                    
                    //ctx.drawImage(this.green_screen_img, 0, 0,  p.ecanvas.width, p.ecanvas.height);

                    const name = this.blockchaininfos.myAccount ? this.blockchaininfos.myAccount : "not loggued";
                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.fillText(name, 16, 48, p.canvas.width - 32);

                    if (p.ectx) {

                        const ctx = p.ectx;

                        
                        ctx.scale(1.0 + (Math.random() - 0.5)* 0.05, 1.0 + (Math.random() - 0.5)* 0.05);
                        ctx.drawImage(this.green_screen_img, 0, 0  ,  p.ecanvas.width, p.ecanvas.height);
                        //ctx.drawImage(this.green_screen_img, 0, h2 ,  p.ecanvas.width, h2);
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        
                        /*
                        ctx.fillStyle = '#000000';
                        ctx.fillRect(0, 0, p.ecanvas.width, p.ecanvas.height);
                        */

                        ctx.fillStyle = '#FFFFFF';
                        ctx.strokeStyle = '#FFFFFF';
                        ctx.globalAlpha = 1.0;
                        ctx.font = "48px impact";
                        ctx.fillText(name, 16, 48, p.canvas.width - 32);

                        this.curEngine.updateETex(p.mesh, 'screen-'+p.name);
                    }
                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                }

                if (p.name === 'steel') {

                    const ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    const name = steels;
                    ctx.fillStyle = '#FFF';
                    ctx.strokeStyle = '#FFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.fillText(name, 16, 48);


                    if (p.ectx) {


                        const ctx = p.ectx;

                        /*
                        ctx.fillStyle = '#000000';
                        ctx.fillRect(0, 0, p.ecanvas.width, p.ecanvas.height);
                        */

                        const h2=p.ecanvas.height /2;
                        ctx.scale(1.0 + (Math.random() - 0.5)* 0.02, 1.0 + (Math.random() - 0.5)* 0.02);
                        ctx.drawImage(this.green_screen_img, 0, 0  ,  p.ecanvas.width, p.ecanvas.height);
                        //ctx.drawImage(this.green_screen_img, 0, h2 ,  p.ecanvas.width, h2);
                        ctx.setTransform(1, 0, 0, 1, 0, 0);

                        ctx.fillStyle = '#FFFFFF';
                        ctx.strokeStyle = '#FFFFFF';
                        ctx.globalAlpha = 1.0;
                        ctx.font = "48px impact";
                        ctx.fillText(name, 16, 48);

                        this.curEngine.updateETex(p.mesh, 'screen-'+p.name);
                    }

                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);

                    //p.mesh.material.map.needsUpdate = true;
                }

                if (p.name === 'coin') {

                    const ctx = p.ctx;
                    ctx.fillStyle = '#' + p.matCol.toString(16);
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    const name = balance;
                    ctx.fillStyle = '#FFF';
                    ctx.strokeStyle = '#FFF';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px impact";
                    ctx.fillText(name, 16, 48);


                    if (p.ectx) {

                        const ctx = p.ectx;

                        const h2=p.ecanvas.height /2;
                        ctx.scale(1.0 + (Math.random() - 0.5)* 0.02, 1.0 + (Math.random() - 0.5)* 0.02);
                        ctx.drawImage(this.green_screen_img, 0, 0  ,  p.ecanvas.width, p.ecanvas.height);
                        //ctx.drawImage(this.green_screen_img, 0, h2 ,  p.ecanvas.width, h2);
                        ctx.setTransform(1, 0, 0, 1, 0, 0);

                        /*
                        ctx.fillStyle = '#000000';
                        ctx.fillRect(0, 0, p.ecanvas.width, p.ecanvas.height);
                        */

                        ctx.fillStyle = '#FFFFFF';
                        ctx.strokeStyle = '#FFFFFF';
                        ctx.globalAlpha = 1.0;
                        ctx.font = "48px impact";
                        ctx.fillText(name, 16, 48);

                        this.curEngine.updateETex(p.mesh, 'screen-'+p.name);

                        //p.mesh.material.emissiveMap.needsUpdate = true;
                    }

                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);

                    //p.mesh.material.map.needsUpdate = true;
                }
            }
        }
        

        async updatePrizesTex() {

            if(!this.userInfos)
                return;

            const curEngine = this.curEngine;
            const prizes = this.userInfos.rewards;

            const hasBuggy = (prizes & 1) ? true : false;
            const hasCar3 = (prizes & 2) ? true : false;
            const hasCar4 = (prizes & 4) ? true : false;
            const hasDavinci = (prizes & 8) ? true : false;
            const hasB2C = (prizes & 16) ? true : false;

            for (let p of this.panels) {

                if (p.panel === 'rewards') {

                    const ctx = p.ctx;
                    const img = p.image;

                    let color = '#' + p.matCol.toString(16);

                    if (p.name === 'buggy') {
                        color = hasBuggy ? '#00FF00' : '#FF0000';
                    } else if (p.name === 'pickup') {
                        color = hasCar3 ? '#00FF00' : '#FF0000';
                    } else if (p.name === 'racing') {
                        color = hasCar4 ? '#00FF00' : '#FF0000';
                    } else if (p.name === 'davinci') {
                        color = hasDavinci ? '#00FF00' : '#FF0000';
                    }else if (p.name === 'upgrade') {
                        color = hasB2C ? '#00FF00' : '#FF0000';
                    }
                    ctx.fillStyle = color;
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    if(img){
                        const flip = this.renderMode == 2? -1 : 1;
                        
                        if (img.complete) {
                            ctx.scale(1 , flip);
                            ctx.fillStyle = '#FFFFFF';
                            ctx.drawImage(img, 0, 0, p.canvas.width, flip * p.canvas.height);
                            ctx.scale(1 , flip);
                        } else {
                            img.onload = function () {
                                ctx.scale(1 , flip);
                                ctx.fillStyle = '#FFFFFF';
                                ctx.drawImage(img, 0, 0, p.canvas.width,  flip * p.canvas.height);
                                curEngine.updateTex(p.mesh, 'screen-'+p.name);
                                ctx.scale(1 , flip);
                            }
                        }
                    }
                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);

                }
            }
        }

        updateInfoBlock(msg) {

            if (msg === this.currentInfoMsg)
                return;

            this.currentInfoMsg = msg;

            for (let p of this.panels) {

                if ((p.panel === 'infoblock') && (p.name === 'infoblock')) {
                    const ctx = p.ctx;
                    const color = '#' + p.matCol.toString(16);
                    ctx.fillStyle = color;
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    if (msg !== null) {
                        ctx.fillStyle = '#FF0000';
                        ctx.font = "48px impact";
                        ctx.textAlign = 'center';
                        ctx.fillText(msg, 128, 48, p.canvas.width);
                    }

                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);

                    //p.mesh.material.map.needsUpdate = true;
                    break;
                }
            }
        }

        updateCarDMG( update){

            if(!this.world.myCar || !this.world.myCar.carDef.DMG)
                return;
            
            const self = this;
            const now = new Date().getTime() / 1000;
            const delta = now - this.world.myCar.carDef.DMG.time;
            const repair_amount = delta * this.world.myCar.carDef.maxdmg / this.gameConfig.repair_time;
            const curdmg = Math.max(parseInt(this.world.myCar.carDef.DMG.damage - repair_amount), 0);
            
            const fullTime = curdmg * this.gameConfig.repair_time / this.world.myCar.carDef.maxdmg;
            const fullTimeTxt = getTimeTxt(fullTime);
            const curlife = this.world.myCar.carDef.maxdmg - curdmg;
        

            if(this.DMGTxt !== null){
                this.curEngine.removeMesh(this.DMGTxt);
                this.curEngine.destroyObj(this.DMGTxt);
                this.DMGTxt=null;
            }

            if(this.dmgMesh !== null){
                this.curEngine.removeMesh(this.dmgMesh);
                this.curEngine.destroyObj(this.dmgMesh);
                this.dmgMesh=null;
            }

            this.DMGTxt = this.createTrackTxt(fullTimeTxt, 0.1, this.timeDMGMat, true, true);
            this.DMGTxt.position.set( this.dmgCenter.x, this.dmgCenter.y, this.dmgCenter.z);
            this.DMGTxt.quaternion.set( this.dmgQuat.x, this.dmgQuat.y, this.dmgQuat.z, this.dmgQuat.w);

            const t = new Transformation3(this.DMGTxt.position, this.DMGTxt.quaternion);
            this.DMGTxt.meshGPU = this.curEngine.addMesh(this.DMGTxt, 1, t);

            const dmgBox = new THREE.BoxGeometry(curlife * this.dmgSize.x / this.world.myCar.carDef.maxdmg, this.dmgSize.y, 0.1);
            this.dmgMesh = new THREE.Mesh(dmgBox, this.DMGMat);

            this.dmgMesh.name ='dmg mesh';

            this.dmgMesh.position.set( this.dmgCenter.x, this.dmgCenter.y, this.dmgCenter.z);
            this.dmgMesh.meshGPU = this.curEngine.addMesh(this.dmgMesh);
            t.set(this.dmgMesh.position, this.dmgMesh.quaternion);
            this.curEngine.updateTransform(this.dmgMesh, t);

            if(update>0)
                this.dmgTimer = setTimeout(function(){ self.updateCarDMG(update); }, update);
        }

        updateCarTex() {

            const curEngine = this.curEngine;
            let carImg;
            let tireImg;
            let engineImg;


            if (this.world.myCar == null) {
                carImg = 'assets/img/nocar.png';
                tireImg = 'assets/img/notire.png';
                engineImg = 'assets/img/nomotor.png';
            } else {

                carImg = getAssetImage(this.world.myCar.carDef, 'cars');
                tireImg = this.world.myCar.carDef.suspension ? getAssetImage(this.world.myCar.carDef.suspension, 'tires') : 'notire.png';
                engineImg = this.world.myCar.carDef.motor ? getAssetImage(this.world.myCar.carDef.motor, 'motors') : 'nomotor.png';
            }

            if(this.initDMGTxt !== null){
                this.curEngine.removeMesh(this.initDMGTxt);
                this.curEngine.destroyObj(this.initDMGTxt);
                this.initDMGTxt=null;
            }

            if(this.dmgMesh !== null){
                this.curEngine.removeMesh(this.dmgMesh);
                this.curEngine.destroyObj(this.dmgMesh);
                this.dmgMesh=null;
            }

            if(this.DMGTxt !== null){
                this.curEngine.removeMesh(this.DMGTxt);
                this.curEngine.destroyObj(this.DMGTxt);
                this.DMGTxt=null;
            }

            if((this.world.myCar !== null)&&(this.world.myCar.carDef.type >= 0)) {

                getDamage(this.blockchaininfos, this.world.myCar.carDef, 0).then(() => {

                    if(!this.world.myCar)
                        return;

                    if(this.world.myCar.carDef.DMG === null){

                        this.initDMGTxt = this.createTrackTxt("init damages", 0.4, this.initDMGMat, true, true);
                        this.initDMGTxt.position.set( this.dmgCenter.x, this.dmgCenter.y, this.dmgCenter.z);
                        this.initDMGTxt.quaternion.set( this.dmgQuat.x, this.dmgQuat.y, this.dmgQuat.z, this.dmgQuat.w);
                        this.initDMGTxt.meshGPU = curEngine.addMesh(this.initDMGTxt);
                        curEngine.setMeshStatic(this.initDMGTxt, false);
                        this.initDMGTxt.name = 'panel-initdmg';


                        curEngine.addSelectable(this.initDMGTxt, this.initDMGTxt.material);
                        this.buttons.push({ obj: this.initDMGTxt, panel: 'initdmg', name: 'initdmg' ,selected : false });
                    }else{

                        if(this.dmgCenter)
                            this.updateCarDMG(1000);
                    }
                });
            }
            
            for (let p of this.panels) {

                if (p.panel === 'car') {

                    if (p.name === 'carmarket') {

                        if (this.world.myCar === null)
                            continue;

                        const ctx = p.ctx;
                        const color = '#' + p.matCol.toString(16);
                        ctx.fillStyle = color;
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                        if ((this.world.myCar.carDef.isDemo === true)) {
                            ctx.fillStyle = '#FF0000';
                            ctx.font = "92px impact";
                            ctx.textAlign = 'center';
                            ctx.fillText('demo', 256, 256, p.canvas.width);
                        } else if ((this.world.myCar.carDef.isfree === true)) {
                            ctx.fillStyle = '#FF0000';
                            ctx.font = "92px impact";
                            ctx.textAlign = 'center';
                            ctx.fillText('free car', 256, 256, p.canvas.width);
                        } else {
                            const carType = document.createElement('img');

                            if (this.world.myCar.carDef.type == 0) {
                                carType.src = "assets/img/simplemarket.svg";
                            } else if (this.world.myCar.carDef.type == 1) {
                                carType.src = "assets/img/atomichub.png";
                            } else if (this.world.myCar.carDef.type == 2) {
                                carType.src = "assets/img/garage-icon.png";
                            } else if (this.world.myCar.carDef.type == 3) {
                                carType.src = "assets/img/mx.png";
                            }

                            if (this.world.myCar.carDef.template_mint > 0) {
                                ctx.fillStyle = '#000000';
                                ctx.font = "48px impact";
                                ctx.textAlign = 'center';
                                ctx.fillText('#' + this.world.myCar.carDef.template_mint.toString(), 256, 48, p.canvas.width);
                            }

                            ctx.fillStyle = '#FFFFFF';
                            carType.onload = function () {
                                ctx.drawImage(carType, 64, 64, 256 + 128, 256 + 128);
                                curEngine.updateTex(p.mesh, 'screen-'+p.name);
                                //p.mesh.material.map.needsUpdate = true;
                            }
                        }
                        //p.mesh.material.map.needsUpdate = true;
                        curEngine.updateTex(p.mesh, 'screen-'+p.name);
                    }

                    if (p.name === 'carthumb') {
                        const ctx = p.ctx;
                        const img = document.createElement('img');
                        const color = '#' + p.matCol.toString(16);

                        ctx.fillStyle = color;
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                        if (this.world.myCar === null) {
                            ctx.fillStyle = '#FF0000';
                            ctx.font = "48px impact";
                            ctx.textAlign = 'center';
                            ctx.fillText('no car selected', 256, 256, p.canvas.width);
                            curEngine.updateTex(p.mesh, 'screen-'+p.name);
                            return;
                        }

                        const carName = this.world.myCar.carDef.name;

                        img.onload = function () {

                            ctx.fillStyle = '#FFFFFF';
                            ctx.drawImage(img, 0, 32, p.canvas.width, p.canvas.height - 32);

                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.textAlign = 'center';
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';
                            ctx.fillText(carName, 256, 48, p.canvas.width);
                            //p.mesh.material.map.needsUpdate = true;
                            curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }
                        
                        img.crossOrigin = "";
                        img.src = curEngine.assetBase+'/assets/nfts/' + carImg;
                    }

                    if (p.name === 'enginethumb') {
                        const ctx = p.ctx;
                        const img = document.createElement('img');
                        let color = '#' + p.matCol.toString(16);

                        const motorName = this.world.myCar.carDef.motor ? this.world.myCar.carDef.motor.name : 'none';

                        img.onload = function () {
                            ctx.fillStyle = color;
                            ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                            ctx.fillStyle = '#FFFFFF';
                            ctx.drawImage(img, 0, 64, p.canvas.width, p.canvas.height - 64);
                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';
                            ctx.fillText(motorName, 256, 48, p.canvas.width);
                            curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }

                        img.crossOrigin = "";
                        img.src = curEngine.assetBase+'/assets/nfts/' + engineImg;
                    }

                    if (p.name === 'tirethumb') {
                        const ctx = p.ctx;
                        const img = document.createElement('img');

                        let color = '#' + p.matCol.toString(16);

                        const tireName = this.world.myCar.carDef.suspension ? this.world.myCar.carDef.suspension.name : 'none';

                        img.onload = function () {
                            ctx.fillStyle = color;
                            ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);
                            ctx.fillStyle = '#FFFFFF';
                            ctx.drawImage(img, 0, 128, p.canvas.width, p.canvas.height - 128);
                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';
                            ctx.fillText(tireName, 256, 48, p.canvas.width);
                            curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }

                        img.crossOrigin = "";
                        img.src = this.blockchaininfos.baseAddr+'/assets/nfts/' + tireImg;
                    }
                }
            }
        }

        updateCarStats(type) {

            for (let p of this.panels) {

                if (p.panel === 'car') {

                    if (p.name === 'carstats') {

                        const ctx = p.ctx;

                        let color = '#' + p.matCol.toString(16);
                        ctx.fillStyle = color;
                        ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                        if ( this.world.myCar === null){
                            this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                            return;
                        }

                        ctx.fillStyle = '#FFFFFF';

                        if (type === 'car') {

                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';
                            ctx.fillText( this.world.myCar.carDef.name, 256, 48, p.canvas.width);

                            ctx.textAlign = 'left';
                            ctx.font = "40px impact";
                            ctx.fillText('weight', 40, 92, p.canvas.width);
                            ctx.fillText('max damage', 40, 122, p.canvas.width);
                            ctx.fillText('sus. length', 40, 152, p.canvas.width);
                            ctx.fillText('max steer', 40, 182, p.canvas.width);
                            ctx.fillText('steer speed', 40, 212, p.canvas.width);

                            ctx.fillText(':' +  this.world.myCar.carDef.massVehicle.toString() + ' Kg', 340, 92, p.canvas.width);
                            ctx.fillText(':' +  this.world.myCar.carDef.maxdmg.toString(), 340, 122, p.canvas.width);
                            ctx.fillText(':' + meshsInfos[ this.world.myCar.carDef.chassis].suspensionRestLength.toString() + ' cm', 340, 152, p.canvas.width);
                            ctx.fillText(':' +  this.world.myCar.carDef.steeringClamp.toFixed(2), 340, 182, p.canvas.width);
                            ctx.fillText(':' +  this.world.myCar.carDef.steeringIncrement.toFixed(2), 340, 212, p.canvas.width);

                            this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }

                        if (type === 'tire') {

                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';

                            if ( this.world.myCar.carDef.suspension)
                                ctx.fillText( this.world.myCar.carDef.suspension.name, 256, 48, p.canvas.width);
                            else
                                ctx.fillText('no tires', 256, 48, p.canvas.width);

                            ctx.textAlign = 'left';
                            ctx.font = "40px impact";
                            ctx.fillText('force', 40, 92, p.canvas.width);
                            ctx.fillText('compression', 40, 122, p.canvas.width);
                            ctx.fillText('relaxation', 40, 152, p.canvas.width);
                            ctx.fillText('stiffness', 40, 182, p.canvas.width);
                            ctx.fillText('grip', 40, 212, p.canvas.width);

                            if ( this.world.myCar.carDef.suspension) {

                                const sus =  this.world.myCar.carDef.suspension;

                                ctx.fillText(':' + sus.force.toFixed(2), 340, 92, p.canvas.width);
                                ctx.fillText(':' + sus.compression.toFixed(2), 340, 122, p.canvas.width);
                                ctx.fillText(':' + sus.damping.toFixed(2) + ' cm', 340, 152, p.canvas.width);
                                ctx.fillText(':' + sus.stiffness.toFixed(2), 340, 182, p.canvas.width);
                                ctx.fillText(':' + sus.friction.toFixed(2), 340, 212, p.canvas.width);
                            } else {
                                ctx.fillText(':--', 340, 92, p.canvas.width);
                                ctx.fillText(':--', 340, 122, p.canvas.width);
                                ctx.fillText(':--', 340, 152, p.canvas.width);
                                ctx.fillText(':--', 340, 182, p.canvas.width);
                                ctx.fillText(':--', 340, 212, p.canvas.width);
                            }

                            this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }

                        if (type === 'motor') {

                            ctx.fillStyle = '#000000';
                            ctx.strokeStyle = '#000000';
                            ctx.font = "48px impact";
                            ctx.globalAlpha = 1.0;
                            ctx.textAlign = 'center';

                            if ( this.world.myCar.carDef.motor)
                                ctx.fillText( this.world.myCar.carDef.motor.name, 256, 48, p.canvas.width);
                            else
                                ctx.fillText('no motor', 256, 48, p.canvas.width);

                            ctx.textAlign = 'left';
                            ctx.font = "40px impact";
                            ctx.fillText('power', 40, 92, p.canvas.width);
                            ctx.fillText('braking', 40, 122, p.canvas.width);

                            if ( this.world.myCar.carDef.suspension) {

                                const mot =  this.world.myCar.carDef.motor;

                                ctx.fillText(':' + mot.maxEngineForce.toString(), 340, 92, p.canvas.width);
                                ctx.fillText(':' + mot.maxBreakingForce.toString(), 340, 122, p.canvas.width);

                            } else {
                                ctx.fillText(':--', 340, 92, p.canvas.width);
                                ctx.fillText(':--', 340, 122, p.canvas.width);
                            }

                            this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                        }
                    }
                }
            }
        }

        setStartable(on) {
            const startc = this.findPanelButton('start', 'start-cont');
            if(!startc)
                    return;
            if (on) {
                
                startc.disabled = false;
                startc.selected = false;
                const start = this.findPanelButton('start', 'start');
                start.disabled = false;
                start.selected = false;
                this.setButtonState(start, start.selected ? 1 : 0);
            } else {
                startc.disabled = true;
                startc.selected = false;
                const start = this.findPanelButton('start', 'start');
                start.disabled = true;
                start.selected = false;
                this.setButtonState(start, 2);
            }
        }

        initSelectableCars() {

            if ( this.world.myCar === null) {
                this.infoMessage = 'select car';
                this.disabledPanelGroup('selectcar', 'selectcar', true);
                return;
            }

            if (this.currentLevel === null) {
                this.setStartable(false);
                    this.infoMessage = 'select track';
            } else {
                this.setStartable(true);
                this.infoMessage = null;
            }

            if ( this.world.myCar.carDef.type == -1) {
                const practicec = this.findPanelButton('racetype', 'racetype-practice-cont');
                practicec.disabled = false;
                practicec.selected = true;
                const practice = this.findPanelButton('racetype', 'racetype-practice');
                practice.disabled = false;
                practice.selected = true;
                this.setButtonState(practice, practice.selected ? 1 : 0);

                const proc = this.findPanelButton('racetype', 'racetype-pro-cont');
                proc.disabled = false;
                proc.selected = false;
                const pro = this.findPanelButton('racetype', 'racetype-pro');
                pro.disabled = false;
                pro.selected = false;
                this.setButtonState(pro, pro.selected ? 1 : 0);

                const pvpc = this.findPanelButton('racetype', 'racetype-pvp-cont');
                pvpc.disabled = true;
                pvpc.selected = false;
                const pvp = this.findPanelButton('racetype', 'racetype-pvp');
                pvp.disabled = true;
                pvp.selected = false;
                this.setButtonState(pvp, 2);

                const newc = this.findPanelButton('gametype', 'gametype-new-cont');
                newc.disabled = false;
                newc.selected = true;
                const newg = this.findPanelButton('gametype', 'gametype-new');
                newg.disabled = false;
                newg.selected = true;
                this.setButtonState(newg, 1);

                const joinc = this.findPanelButton('gametype', 'gametype-join-cont');
                joinc.disabled = false;
                joinc.selected = false;
                const join = this.findPanelButton('gametype', 'gametype-join');
                join.disabled = false;
                join.selected = false;
                this.setButtonState(join, 2);
                return;
            }

            if ( this.world.myCar.carDef.type == -2) {

                const practicec = this.findPanelButton('racetype', 'racetype-practice-cont');
                practicec.disabled = false;
                practicec.selected = true;
                const practice = this.findPanelButton('racetype', 'racetype-practice');
                practice.disabled = false;
                practice.selected = true;
                this.setButtonState(practice, 1);

                const proc = this.findPanelButton('racetype', 'racetype-pro-cont');
                proc.disabled = true;
                proc.selected = false;
                const pro = this.findPanelButton('racetype', 'racetype-pro');
                pro.disabled = true;
                pro.selected = false;
                this.setButtonState(pro, 2);

                const pvpc = this.findPanelButton('racetype', 'racetype-pvp-cont');
                pvpc.disabled = true;
                pvpc.selected = false;
                const pvp = this.findPanelButton('racetype', 'racetype-pvp');
                pvp.disabled = true;
                pvp.selected = false;
                this.setButtonState(pvp, 2);

                const joinc = this.findPanelButton('gametype', 'gametype-join-cont');
                joinc.disabled = true;
                joinc.selected = false;
                const join = this.findPanelButton('gametype', 'gametype-join');
                join.disabled = true;
                join.selected = false;
                this.setButtonState(join, 2);

                const newc = this.findPanelButton('gametype', 'gametype-new-cont');
                newc.disabled = false;
                newc.selected = true;
                const newg = this.findPanelButton('gametype', 'gametype-new');
                newg.disabled = false;
                newg.selected = true;
                this.setButtonState(newg, 1);
                return;
            }


            const proc = this.findPanelButton('racetype', 'racetype-pro-cont');
            proc.disabled = false;
            const pro = this.findPanelButton('racetype', 'racetype-pro');
            pro.disabled = false;
            this.setButtonState(pro, pro.selected ? 1 : 0);

            const pvpc = this.findPanelButton('racetype', 'racetype-pvp-cont');
            pvpc.disabled = false;
            const pvp = this.findPanelButton('racetype', 'racetype-pvp');
            pvp.disabled = false;
            this.setButtonState(pvp, pvp.selected ? 1 : 0);

            this.disabledPanelGroup('racetype', null, false);
            this.disabledPanelGroup('gametype', null, false);
            this.selectPanelButton('racetype', 'racetype-practice');
            this.selectPanelButton('gametype', 'gametype-new');
        }

        setButtonState(b, state) {

            const panel = b.panel;
            const name = b.name;
            const curEngine = this.curEngine;

            if ((panel == 'rclass') || (panel == 'tclass') || panel == 'maptrack-C') {

                const col = curEngine.getColor(b.obj, b.name);

                switch (state) {
                    case 1:
                        curEngine.setEmission(b.obj, b.name, col.r, Math.max(col.g, 0.1), col.b, 8.0)
                    break;
                    default:
                        curEngine.setEmission(b.obj, b.name,0, 0, 0 , 1);
                    break;
                }
            }

            if (panel == 'tracklistnav') {

                if ((b.name === 'tracklist-next')||(b.name === 'tracklist-previous')) {
                    switch (state) {
                        case 1:
                            curEngine.setEmission(b.obj, b.name, 0, 1, 0, 8.0)
                        break;
                        default:
                            curEngine.setEmission(b.obj, b.name,0, 0, 0 , 1);
                        break;
                    }
                }
            }

            if (panel == 'initdmg') {

                if (name == 'initdmg') {
    
                    switch (state) {
                        case 1:
                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0)
                        break;
                        case 2:
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                        break;
                        default:
                            curEngine.setColor(b.obj, b.name,1.0, 0.2, 0.2);
                        break;
                    }
                }
            }

            if ((panel == 'missionsok')) {

                switch (state) {
                    case 1:
                        if (this.missionsOkTxt) {
                            curEngine.setColor(this.missionsOkTxt.o, this.missionsOkTxt.m.name, 1.0, 1.0, 1.0);
                            curEngine.setEmission(this.missionsOkTxt.o, this.missionsOkTxt.m.name, 0.2, 0.2, 0.2 , 2.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        } else if(name == "missionsok"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                        }
                        break;
                    case 2:
                        if (this.missionsOkTxt) {
                            curEngine.setColor(this.missionsOkTxt.o, this.missionsOkTxt.m.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(this.missionsOkTxt.o, this.missionsOkTxt.m.name,0.0, 0.0, 0.0 , 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.0, 0.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 4.0);
                        } else if(name == "missionsok"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                    default:
                        if (this.missionsOkTxt) {
                            curEngine.setColor(this.missionsOkTxt.o, this.missionsOkTxt.m.name, 1.0, 1.0, 1.0);
                            curEngine.setEmission(this.missionsOkTxt.o, this.missionsOkTxt.m.name,0.0, 0.0, 0.0 , 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else if(name == "missionsok"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                }

            }

            if ((panel == 'missionsrefresh')) {

                switch (state) {
                    case 1:
                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        } else if(name == "missionsrefresh"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                        }
                        break;
                    case 2:
                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.0, 0.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 4.0);
                        } else if(name == "missionsrefresh"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                    default:
                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else if(name == "missionsrefresh"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                }

            }

            if ((panel == 'start')) {

                switch (state) {
                    case 1:
                        if (this.startTxt) {
                            curEngine.setColor(this.startTxt.o, this.startTxt.m.name, 1.0, 1.0, 1.0);
                            curEngine.setEmission(this.startTxt.o, this.startTxt.m.name, 0.2, 0.2, 0.2 , 2.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        } else if( name === "start"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                        }
                        break;
                    case 2:
                        if (this.startTxt) {
                            curEngine.setColor(this.startTxt.o, this.startTxt.m.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(this.startTxt.o, this.startTxt.m.name,0.0, 0.0, 0.0 , 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.0, 0.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 4.0);
                        } else if( name === "start"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                    default:
                        if (this.startTxt) {
                            curEngine.setColor(this.startTxt.o, this.startTxt.m.name, 1.0, 1.0, 1.0);
                            curEngine.setEmission(this.startTxt.o, this.startTxt.m.name,0.0, 0.0, 0.0 , 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else if( name === "start"){
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                }
            }

            if ((panel == 'jukebox')) {

                if ((name.startsWith('song'))) {
    
                    switch (state) {

                        case 1:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name,0.2, 1.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                            }
                            break;
                        case 2:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            break;
                        default:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name,1.0, 0.2, 0.2);
                                curEngine.setEmission(b.obj, b.name, 1.0, 0.2, 0.2, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name,1.0, 0.2, 0.2);
                                curEngine.setEmission(bb.obj, bb.name, 1.0, 0.2, 0.2, 1.0);
                            }
                        break;
                    }
                }
            }

            if ((panel == 'gametype')) {

                const arr = name.split('-');
                const gametype = arr[1];

                switch (state) {
                    case 1:
                        if (this.gametypeTxt.hasOwnProperty(gametype)) {
                            curEngine.setColor(this.gametypeTxt[gametype].o, null, 1.0, 1.0, 1.0);
                            curEngine.setEmission(this.gametypeTxt[gametype].o, null, 0.2, 0.2, 0.2, 2.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name,0.2, 1.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                        }
                        break;
                    case 2:
                        if (this.gametypeTxt.hasOwnProperty(gametype)) {
                            curEngine.setColor(this.gametypeTxt[gametype].o, null, 0.0, 0.0, 0.0)
                            curEngine.setEmission(this.gametypeTxt[gametype].o, null, 0.0, 0.0, 0.0, 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                    default:
                        if (this.gametypeTxt.hasOwnProperty(gametype)) {
                            curEngine.setColor(this.gametypeTxt[gametype].o, null, 1.0, 1.0, 1.0)
                            curEngine.setEmission(this.gametypeTxt[gametype].o, null, 0.0, 0.0, 0.0, 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                }
            }

            if ((panel == 'wallets')) {
                
                if(b.group === 'wallets'){
                    
                    switch (state) {
                        case 1:
    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name,0.8, 1.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.8, 1.0, 0.0, 4.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name,0.8, 1.0, 0.0);
                                curEngine.setEmission(bb.obj, bb.name, 0.8, 1.0, 0.0, 4.0);
                            }
                            break;
                        case 2:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            break;
                        default:
                    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                        break;
                    }

                }
            }

            if ((panel == 'login')) {

                if(b.group === 'net') {

                    const arr = name.split('-');
                    
                    switch (state) {
                        case 1:

                            if(b.name.startsWith('mainnet')){
                                const txt = this.netTexts['mainnet'];
                                curEngine.setColor(txt.o, txt.m.name,0.2, 1.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.2, 1.0, 0.0, 4.0);
                            }
    
                            if(b.name.startsWith('testnet')){
                                const txt = this.netTexts['testnet'];
                                curEngine.setColor(txt.o, txt.m.name,0.2, 1.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.2, 1.0, 0.0, 4.0);
                            }

                            if(b.name.startsWith('localnet')){
                                const txt = this.netTexts['localnet'];
                                curEngine.setColor(txt.o, txt.m.name,0.2, 1.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.2, 1.0, 0.0, 4.0);
                            }

                            curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        break;
                        case 2:

                            if(b.name.startsWith('mainnet')){
                                const txt = this.netTexts['mainnet'];
                                curEngine.setColor(txt.o, txt.m.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.0, 0.0, 0.0, 1.0);
                            }

                            if(b.name.startsWith('testnet')){
                                const txt = this.netTexts['testnet'];
                                curEngine.setColor(txt.o, txt.m.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.0, 0.0, 0.0, 1.0);
                            }

                            if(b.name.startsWith('localnet')){
                                const txt = this.netTexts['localnet'];
                                curEngine.setColor(txt.o, txt.m.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(txt.o, txt.m.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            break;
                        default:

                            if(b.name.startsWith('mainnet')){
                                const txt = this.netTexts['mainnet'];
                                curEngine.setColor(txt.o, txt.m.name,  0.2, 1.0, 0.0)
                                curEngine.setEmission(txt.o, txt.m.name,  0.0, 0.0, 0.0, 1.0)
                            }

                            if(b.name.startsWith('testnet')){
                                const txt = this.netTexts['testnet'];
                                curEngine.setColor(txt.o, txt.m.name,  0.2, 1.0, 0.0)
                                curEngine.setEmission(txt.o, txt.m.name,  0.0, 0.0, 0.0, 1.0)
                            }

                            if(b.name.startsWith('localnet')){
                                const txt = this.netTexts['localnet'];
                                curEngine.setColor(txt.o, txt.m.name,  0.2, 1.0, 0.0)
                                curEngine.setEmission(txt.o, txt.m.name,  0.0, 0.0, 0.0, 1.0)
                            }
                    
                    
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        break;
                    }

                }

                if(b.group === 'login'){
                    
                    switch (state) {
                        case 1:
    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name,0.2, 1.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name,0.2, 1.0, 0.0);
                                curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                            }
                            break;
                        case 2:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            break;
                        default:
                    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                        break;
                    }

                }
            }

            if ((panel == 'racetype')) {

                const arr = name.split('-');
                const racetype = arr[1];

                switch (state) {
                    case 1:
                        if (this.racetypeTxt.hasOwnProperty(racetype)) {
                            curEngine.setColor(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0)
                            curEngine.setEmission(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0, 4.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                        }
                        break;
                    case 2:
                        if (this.racetypeTxt.hasOwnProperty(racetype)) {
                            curEngine.setColor(this.racetypeTxt[racetype].o, null, 1.0, 0.0, 0.0)
                            curEngine.setEmission(this.racetypeTxt[racetype].o, null, 1.0, 0.0, 0.0, 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 1.0, 0.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 1.0, 0.0, 0.0, 1.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 1.0, 0.0, 0.0)
                            curEngine.setEmission(bb.obj, bb.name, 1.0, 0.0, 0.0, 1.0);
                        }
                        break;
                    default:
                        if (this.racetypeTxt.hasOwnProperty(racetype)) {
                            curEngine.setColor(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0)
                            curEngine.setEmission(this.racetypeTxt[racetype].o, null, 0.0, 0.0, 0.0, 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                        }
                        break;
                }
            }

            if ((panel == 'selectcar')) {
                if ((name === 'next-car') || (name === 'prev-car')) {

                    switch (state) {
                        case 1:
                            curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        break;
                        case 2:
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0)
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                        break;
                        default:
                            curEngine.setColor(b.obj, b.name, 1.0, 0.2, 0.2)
                            curEngine.setEmission(b.obj, b.name, 1.0, 0.2, 0.2, 1.0);
                        break;
                    }
                }

                if ((name == 'freecar')) {

                    switch (state) {

                        case 1:
                            if (this.freecarTxt) 
                                curEngine.setEmission(this.freecarTxt.o, this.freecarTxt.m.name, 0.2, 1.0, 0.0, 4.0);
                            
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        break;
                        default:
                            if (this.freecarTxt)
                                curEngine.setEmission(this.freecarTxt.o, this.freecarTxt.m.name, 1.0, 0.2, 0.2, 1.0);
                            
                            curEngine.setEmission(b.obj, b.name, 1.0, 0.2, 0.2, 1.0);
                        break;
                    }

                }

                if ((name.startsWith('selectcar'))) {

                    const id = parseInt(name[9]);

                    switch (state) {

                        case 1:
                            if (name.endsWith('-cont')) {

                                curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                            }
                            break;
                        case 2:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            break;
                        default:
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 1.0, 0.2, 0.2)
                                curEngine.setEmission(b.obj, b.name, 1.0, 0.2, 0.2, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 1.0, 0.2, 0.2)
                                curEngine.setEmission(bb.obj, bb.name, 1.0, 0.2, 0.2, 1.0);
                            }
                            break;
                    }
                }
    
                if ((name == 'mycars')) {

                    switch (state) {
                        case 1:
                            if (this.mycarsTxt)
                                curEngine.setEmission(this.mycarsTxt.o, this.mycarsTxt.m.name, 0.2, 1.0, 0.0, 4.0);
                            
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                        break;
                        case 2:
                            if (this.mycarsTxt) {
                                curEngine.setEmission(this.mycarsTxt.o, this.mycarsTxt.m.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(this.mycarsTxt.o, this.mycarsTxt.m.name, 0.0, 0.0, 0.0);
                            }
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                        break;
                        default:
                            if (this.mycarsTxt) 
                                curEngine.setEmission(this.mycarsTxt.o, this.mycarsTxt.m.name, 1.0, 0.2, 0.2, 1.0);

                            curEngine.setEmission(b.obj, b.name, 1.0, 0.2, 0.2, 1.0);

                        break;
                    }
                }
            }

            if (panel == 'weather')  {

                const arr = name.split('-');
                const env = arr[1];

                switch (state) {
                    case 2:
                        if (this.envTxt[env]) {
                            curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                        }
                    break;
                    case 1:
                        if (this.envTxt[env]){
                            curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.2, 1.0, 0.0, 4.0);
                            curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 0.2, 1.0, 0.0);
                        }
                            

                        if (name.endsWith('-cont')) {
                            curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                            curEngine.setColor(b.obj, b.name,  0.2, 1.0, 0.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                            curEngine.setColor(bb.obj, bb.name,  0.2, 1.0, 0.0);
                        }
                    break;
                    default:
                        if (this.envTxt[env]) {
                            curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 1.0, 1.0, 1.0);
                        }

                        if (name.endsWith('-cont')) {
                            curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(b.obj, b.name, 1.0, 1.0, 1.0);
                        } else {
                            const bb = this.findPanelButton(panel, name + '-cont');
                            curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            curEngine.setColor(bb.obj, bb.name, 1.0, 1.0, 1.0);
                        }
                    break;
                }
            }
        }

        findPanelButton(panel, name) {

            for (var b of this.buttons) {

                if ((panel === b.panel) && (b.name == name))
                    return b;
            }

            return null;

        }

        disabledPanelGroup(panel, group, on) {

            for (var b of this.buttons) {

                if ((panel === b.panel) && (group === b.group)) {
                    b.disabled = on;
                    this.setButtonState(b, b.disabled === true ? 2 : b.selected === true ? 1 : 0);
                }
            }
        }

        setTracks(tracks){
            this.tracks = tracks;
        }
        
        async getGames() {
            const res = await fetch('/api/getOpenGames');
            this.games = await res.json();
        }

        async getMyCar() {
                                
            try {
                const carDef = await getCar(this.blockchaininfos, this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype);
                if (carDef !== null) {

                    if (this.blockchaininfos.selectedCartype == -1)
                        this.carSelectMode = 0;
                    else
                        this.carSelectMode = 1;

                    if (this.blockchaininfos.selectedCartype == -2) {
                        carDef.isDemo = true;
                    }
                    this.world.myCar = new Car(this.world.carid++, carDef);
                    //setSelectedCar(carDef);
                }
            } catch (e) {
                alert('unable to get car ' + e.message);
            }
        }
        
        initEngine()
        {
            if(this.curEngine === null)
                return false;

            this.curEngine.renderer.setClearColor(0xFFFFFFFF, 1);

            this.curEngine.renderer.shadowMap.enabled = true;
            this.curEngine.renderer.shadowMapSoft = true;
            this.curEngine.renderer.shadowMap.type = THREE.PCFSoftShadowMap;///THREE.PCFSoftShadowMap; //Basicshadowmap //PCFShadowMap

            return true;
        }

        initEngineWebGPU() {
            this.curEngine.camMode = 1;
        }


        addCarScene(){
            const t = new Transformation3();

            this.carGroup = new THREE.Group();
            this.carGroup.name = 'car pod group';
            this.curEngine.addMeshChild(this.podcar ,this.carGroup);
            
            if(!this.world.myCar.ChassisMesh)
                return; 
            
            this.curEngine.addMeshChild(this.carGroup ,this.world.myCar.ChassisMesh);

            if(this.renderMode == 2)
                this.world.myCar.updateWheels(2);
            else
                this.world.myCar.updateWheels(0);

            this.world.myCar.ChassisMesh.position.y = meshsInfos[this.world.myCar.carDef.chassis].chassisOffset;

            t.set(this.world.myCar.ChassisMesh.position, this.world.myCar.ChassisMesh.quaternion);
            this.curEngine.updateTransform(this.world.myCar.ChassisMesh, t);

            this.curEngine.setMeshStatic(this.world.myCar.ChassisMesh, false);

            if(this.world.myCar.weapon){
                const weapon = this.world.myCar.weapon;
    
                weapon.canon.position.set(weapon.canonRel.x, weapon.canonRel.y, weapon.canonRel.z);
                weapon.head.position.set(weapon.headRel.x, weapon.headRel.y, weapon.headRel.z);

                this.curEngine.addMeshChild(weapon.head, weapon.canon);
                this.curEngine.addMeshChild(weapon.body, weapon.head);
                this.curEngine.addMeshChild(this.world.myCar.ChassisMesh, weapon.body);

                this.curEngine.setMeshStatic(weapon.head, false);
                this.curEngine.setMeshStatic(weapon.canon, false);
                this.curEngine.setMeshStatic(weapon.body, false);
            }

            if(this.world.myCar.radar){

                const radar = this.world.myCar.radar;
                this.curEngine.addMeshChild(this.world.myCar.ChassisMesh, radar);
                t.set(radar.position);
                this.curEngine.updateTransform(radar, t);
                this.curEngine.setMeshStatic(radar, false);
            }

            for (let w of this.world.myCar.wheels) {

                //w.mesh.scale.set(w.scale.x,1,1);
                const et= new Transformation3();

                this.curEngine.addMeshChild(this.carGroup, w.mesh, {x: w.pos.x < 0 ? false : true, y: false, z : false});
                this.curEngine.setMeshStatic(w.mesh, false);

                t.set(w.mesh.position, w.mesh.quaternion);
                this.curEngine.updateTransform(w.mesh, t);
            }

            this.carGroup.position.y += 1;

            t.set(this.carGroup.position, this.carGroup.quaternion);
            this.curEngine.updateTransform(this.carGroup, t);
        }

        async updateCar(carid, cartype) {
            await this.getMyCar(carid, cartype);
            this.updateCarTex();
            this.updateCarStats('car');

            await this.curEngine.loadCar(this.world.myCar);
            this.addCarScene();
        }

        getSelectedButton(panel, group) {

            for (var b of this.buttons) {
                if ((panel === b.panel) && ((group == null) || (group === b.group))) {

                    if (b.selected)
                        return b.value;
                }
            }
            return null;
        }

        setNetwork(network){
            this.selectedNetwork = network;
            this.updateWalletSelected();
        }

        setBlockchain(blockchain){
            this.selectedBlockchain = blockchain;


            switch(this.selectedBlockchain){
                case BC_WAX : this.targetWalletBoadAngle = Math.PI;break;
                case BC_SOLANA : this.targetWalletBoadAngle = 0.0;break;
            }
            


            this.updateWalletSelected();
        }

        getSelectedNetwork(){

            const blockchains = ['wax', 'solana'];
            return blockchains[this.selectedBlockchain]+'-'+this.selectedNetwork;

        }

        async initDmg(){
            
            switch(this.blockchaininfos.bc_type){
                case BC_WAX:return await initdmgWax (this.blockchaininfos.myAccount, this.blockchaininfos.logType, this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype, this.blockchaininfos.mainContract);break;
                case BC_SOLANA:return await initdmgSOL(this.blockchaininfos, this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype);break;
            }
        }

        



        async selectPanelButton(panel, name, group = null) {

            let dg = null;

            for (var b of this.buttons) {

                if ((panel === b.panel) && ((group == null) || (group === b.group))) {

                    const cname = b.name.endsWith('-cont') ? b.name.substr(0, b.name.length - 5) : b.name;
                    const selected = (cname == name) ? true : false;

                    if (b.selected || selected) {
                        
                        if (name === 'tracklist-next') {
                            this.nextTrack();
                        }
                        
                        if (name === 'tracklist-previous') {
                            this.prevTrack();
                        }

                        if (name.startsWith('next-car')) {

                            if (( this.firstElement + 4) < this.blockchaininfos.assetLists['cars'].length) {
                                    this.firstElement++;
                                    this.updateCarList();
                            }
                        }

                        if (name.startsWith('prev-car')) {

                            if ( this.firstElement > 0) {
                                    this.firstElement--;
                                    this.updateCarList();
                            }
                        }

                        if (name === 'initdmg') {
                            this.initDmg(this.world.myCar.carDef.id, this.world.myCar.carDef.type).then((res)=>{

                                if(res)
                                    this.updateCarTex();
                                else
                                    alert('init damage failed ');
                            })
                            return;
                        }

                        if (name === 'missionsrefresh') {
                            b.disabled = true;
                            this.setButtonState(b, 2);

                            const assTypes = this.blockchaininfos.bc_type == BC_SOLANA ? 4 : 3;
                            await getAssets(this.blockchaininfos, ['cars'], assTypes);

                            this.steelImage = null;

                            this.updateMission();
                            b.selected = false;
                            b.disabled = false;
                            this.setButtonState(b, 0);
                            return;
                        }
                        

                        
                        if (name === 'missionsok') {

                            const id = this.missionCar !== null ? parseInt(this.missionCar.id) : 0;
                            const type = this.missionCar !== null ? this.missionCar.type : 0;

                            checkquest(id, type).then(async (res)=> {

                                if(res){
                                    await sleep(2000);
                                    this.updateMission();
                                }
                                else
                                    alert('cannot check quest');
                            })
                            return;
                        }

                        

                        if (name.startsWith('songdown')) {
    
                            if (( this.firstSong + 3) < songs.length) {
                                this.firstSong++;
                                this.updateSongs();
                            }
                        }else if (name.startsWith('songup')) {

                            if ( this.firstSong > 0) {
                                this.firstSong--;
                                this.updateSongs();
                            }
                        }
                    }

                    if ((selected === true) && (b.selected === false)) {

                        if ((!name.endsWith('-cont'))&&(!b.name.endsWith('-cont'))) {

                            if (name.startsWith('songdown')) {
                                        
                            }else if (name.startsWith('songup')) {
    
                            }else if (name.startsWith('song')) {

                                const id = parseInt(name.substr(4)) - 1 + this.firstSong;
                                const song = songs[id];

                                this.selectedSong = id;
                                
                                this.curEngine.stopMusic();
                                this.curEngine.playMusic(("/assets/snd/"+song.file));

                                this.curEngine.AudioMusic.play();

                                const bb = this.findPanelButton('jukebox', b.name + '-cont');
                                if (bb)
                                    bb.selected = true;

                            }else if (name.startsWith('waxlogin')) {

                                const network = this.getSelectedNetwork();

                                const res = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype=-1&account=&mode=1', { credentials:'include', redirect: 'manual'});
                                const config = await res.json();
                                const account =await waxlogin(config.endpoints[0]);

                                if(account !== null){
                                    const res2 = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype='+WCW+'&account='+account+'&mode=1', { credentials:'include', redirect: 'manual'});
                                    this.blockchaininfos = await res2.json();
                                    this.setBCInfos(this.blockchaininfos);

                                    localStorage.removeItem('endpoint');

                                    await resetwax();
                                    await initwax(this.blockchaininfos.endpoints[0], this.blockchaininfos.AA.contract);

                                    await this.getCarList();
                                    await this.getMyCar();
                                }


                            }else if (name.startsWith('anchorlogin')) {

                                const network = this.getSelectedNetwork();

                                const res = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype=-1&account=&mode=1', { credentials:'include', redirect: 'manual'});
                                const config = await res.json();
                                const account = await linkLogin(config.chainId, config.endpoints[0]);

                                if(account !== null){
                                    const res2 = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype='+ANCHOR+'&account='+account+'&mode=1', { credentials:'include', redirect: 'manual'});
                                    this.blockchaininfos = await res2.json();
                                    this.setBCInfos(this.blockchaininfos);

                                    localStorage.removeItem('endpoint');

                                    await resetwax();
                                    await initwax(this.blockchaininfos.endpoints[0], this.blockchaininfos.AA.contract);
                                    await initanchor(this.blockchaininfos.endpoints[0], this.blockchaininfos.chainId);

                                    await this.getCarList();
                                    await this.getMyCar();
                                }
             
                            }else if (name.startsWith('phantomlogin')) {

                                const network = this.getSelectedNetwork();

                                const account = await phantomLogin();

                                if(account !== null){
                                    const res2 = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype='+PHANTOM+'&account='+account+'&mode=1', { credentials:'include', redirect: 'manual'});
                                    this.blockchaininfos = await res2.json();
                                    this.setBCInfos(this.blockchaininfos);

                                    localStorage.removeItem('endpoint');

                                    resetsolana();
                                    await initsolana(this.blockchaininfos.endpoints[0]);
                                    await this.getCarList();
                                    await this.getMyCar();

                                }

                            }else if (name.startsWith('backpacklogin')) {
                                const network = this.getSelectedNetwork();
                                const account = await backpackLogin();

                                 if(account !== null){
                                    const res2 = await fetch(this.blockchaininfos.baseAddr+'/api/setsession?network='+network+'&logtype='+BACKPACK+'&account='+account+'&mode=1', { credentials:'include', redirect: 'manual'});
                                    this.blockchaininfos = await res2.json();
                                    this.setBCInfos(this.blockchaininfos);

                                    localStorage.removeItem('endpoint');

                                    resetsolana();
                                    await initsolana(this.blockchaininfos.endpoints[0]);
                                    await this.getCarList();
                                    await this.getMyCar();
                                 }

                            }else if (name.startsWith('mainnet')) {
                                await this.setNetwork('mainnet'); 
                            }else if (name.startsWith('testnet')) {
                                await this.setNetwork('testnet'); 
                            }else if (name.startsWith('localnet')) {
                                await this.setNetwork('localnet'); 

                            }else if (name.startsWith('solana')) {
                                await this.setBlockchain(BC_SOLANA); 

                            }else if (name.startsWith('wax')) {
                                await this.setBlockchain(BC_WAX); 

                            }else if (name === 'gametype-join') {

                                this.setStaticPanelButton('racetype', 'racetype-pvp', 'racetype');
                                this.gameMode = 'join';
                                await this.getGames();
                                this.updateGameList(this.currentTrackClass);
                            }else if (name === 'gametype-new') {

                                this.disabledPanelGroup('racetype', 'racetype', false);
                                this.disabledPanelGroup('weather', 'weather', false);
                                this.gameMode = 'new';
                                this.updateTrackList(this.currentTrackClass);
                            }else if (name.startsWith('start')) {
                                const self = this;
    
                                if(this.gameMode === 'new'){
                                    const rt = this.getSelectedButton('racetype', null);
                                    const np = rt === 'pvp' ? 2 : 1;
        
                                    const et = this.getSelectedButton('weather', null);
                                    const url = this.blockchaininfos.baseAddr+"/api/startGame?trackname=" + this.currentLevel + "&serverID=" + selectedServer + '&np=' + np + '&env=' + et + '&type=' + rt;
    
                                    fetch(url, { credentials: "include"}).then(async (res) =>{ 
                                        const o = await res.json(); 
                                        if(o.result) 
                                            self.screenChanger.changeScreen('play', true); 
                                        else 
                                            alert('could not start game '+o.error);  
                                    });
                                }else{
                                    const url = '/api/joinGame?gameID=' + this.selectedGame.id;
                                    fetch(url).then((res) =>{ self.screenChanger.changeScreen('play', true); });
                                }
                            }
                        }

                        if(panel === 'tclass'){
                            this.currentTrackClass = b.value;
                            this.firstElement = 0;
                            this.updateTrackList(this.currentTrackClass);
                        }

                        if (panel === 'selectcar') {

                            if (name.startsWith('selectcar')) {

                                if(( this.firstElement + b.value)< this.blockchaininfos.assetLists['cars'].length){
                                    
                                    const asset = this.blockchaininfos.assetLists['cars'][ this.firstElement + b.value];
                                    
                                    this.hover.HoverButton = null;
    
                                    dg = { p: panel, g: 'selectcar', s: true };
                                    this.curEngine.removeMeshChild(this.podcar, this.carGroup);
                                    this.curEngine.removeCar(this.world.myCar);

                                    const url = this.blockchaininfos.baseAddr+'/api/setcar?carid=' + asset.id + '&cartype=' + asset.type;
                                    fetch(url, {credentials : 'include'}).then(async (res) => {
                                        this.blockchaininfos.selectedCarid = asset.id;
                                        this.blockchaininfos.selectedCartype = asset.type;

                                        this.updateCar(this.blockchaininfos.selectedCarid, this.blockchaininfos.selectedCartype).then(()=>{
                                            this.disabledPanelGroup(panel, 'selectcar', false);
                                            this.initSelectableCars();
                                        })
                                    });
                                }
                            }

                            if (name.startsWith('freecar')) {

                                this.carSelectMode = 0;
                                this.hover.HoverButton = null;

                                dg = { p: panel, g: 'selectcar', s: true };

                                this.updateCarList();
                                this.curEngine.removeMeshChild(this.podcar, this.carGroup);

                                this.curEngine.removeCar(this.world.myCar);

                                this.blockchaininfos.selectedCarid = 1;
                                this.blockchaininfos.selectedCartype = -1;

                                this.updateCar().then(()=>{
                                    this.disabledPanelGroup(panel, 'selectcar', false);
                                    this.initSelectableCars();
                                })
                            }

                            if (name.startsWith('mycars')) {

                                this.carSelectMode = 1;
                                this.updateCarList();
                            }
                            
                            if (!b.name.endsWith('-cont')) {
                                const bb = this.findPanelButton('selectcar', b.name + '-cont');
                                if (bb)
                                    bb.selected = true;
                            } else {
                                const bb = this.findPanelButton('selectcar', b.name.substr(0, b.name.length - 5));
                                if (bb)
                                    bb.selected = true;
    
                            }
                        }
                        this.setButtonState(b, b.disabled ? 2 : 1);
                    }


                    if ((selected === false) && (b.selected === true)) {
                        if (!b.name.endsWith('-cont')) {
                            const bb = this.findPanelButton('selectcar', b.name + '-cont');
                            if (bb)
                                bb.selected = false;
                        } else {
                            const bb = this.findPanelButton('selectcar', b.name.substr(0, b.name.length - 5));
                            if (bb)
                                bb.selected = false;
                        }
                        this.setButtonState(b, b.disabled ? 2 : 0);
                    }

                    b.selected = selected;
                    //console.log('selected button ' + b.panel + ' ' + b.name + ' ' + selected);
                }
            }

            if (dg !== null)
                this.disabledPanelGroup(dg.p, dg.g, dg.s);
        }

        setStaticPanelButton(panel, name, group = null) {

            for (var b of this.buttons) {
                if ((panel === b.panel) && ((group === null) || (group === b.group))) {

                    const cname = b.name.endsWith('-cont') ? b.name.substr(0, b.name.length - 5) : b.name;

                    const selected = (cname == name) ? true : false;

                    if (selected) {
                        b.selected = true;
                        b.disabled = false;
                        this.setButtonState(b, 1);
                    } else {
                        b.selected = false;
                        b.disabled = true;
                        this.setButtonState(b, 2);
                    }
                }
            }
        }


        createTrackTxt(txt, size, mat, center = null, vcenter = null) {

            const Txt = new TextGeometry(txt, {
                font: this.curEngine.speedFont,
                size: size,
                height: 0.01,
                curveSegments: 12,
                bevelEnabled: true,
                bevelThickness: 0.1,
                bevelSize: 0.01,
                bevelOffset: 0,
                bevelSegments: 4
            });
            Txt.computeBoundingBox();
            Txt.computeBoundingSphere();

            const sz = new THREE.Vector3(); 
            Txt.boundingBox.getSize(sz);

            Txt.translate(center ? -sz.x / 2.0 : 0, vcenter ? -sz.y / 2.0 : -1, 0);
            const txtMesh = new THREE.Mesh(Txt, mat);

            txtMesh.name = 'txt '+txt;

            return txtMesh;
        }

        async createTrackThumbTex(track){
            const level = track.name;

            let prize = '';

            if (track.prize === 'car3')
                prize = 'pickup';
            else if (track.prize === 'car4')
                prize = 'racing';
            else if (track.prize === 'c2b')
                prize = 'upgrade';
            else
                prize = track.prize;

            const img = document.createElement('img');
            img.src = this.blockchaininfos.baseAddr+ '/assets/tracks/' + level + '.png';
            img.crossOrigin = "";
            const tex = new THREE.Texture(img);
            
            const rewardImg = document.createElement('img');

            if(prizes.hasOwnProperty(prize))
                rewardImg.src = prizes[prize];
            else
                rewardImg.src ='assets/img/norew.png';

            const tw = new CircuitRace(this.curEngine);
            let roadObj = null;
            await tw.loadTrack(level, this.blockchaininfos.baseAddr);

            if(tw.track.trackPoints.length>1){

                this.curEngine.createRoadMat(tw.track);

                await this.curEngine.makeTrack(tw.track);

                if(tw.track.roadObj){
                    roadObj = tw.track.roadObj.clone();

                    const sz = 2;
                    const bbsz = new THREE.Vector3();
                    const bbc = new THREE.Vector3();

                    roadObj.geometry.computeBoundingBox();
                    roadObj.geometry.boundingBox.getSize(bbsz);
                    roadObj.geometry.boundingBox.getCenter(bbc);
                    roadObj.geometry.translate(-bbc.x, -bbc.y, -bbc.z)
                    roadObj.geometry.scale(sz /bbsz.x, sz /bbsz.x, sz /bbsz.x );
                    roadObj.material = new THREE.MeshPhongMaterial({color: 0xFFFFFF});
                }
            }

            this.trackThumbs[track.name] = { img: img, rimg: rewardImg, tex: tex, road: roadObj };
        }

        setScreenText(name, text){
            for (let p of this.panels) {

                if (p.name === name) {

                    const ctx = p.ctx;
                    
                    ctx.fillStyle = '#000000';
                    ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                    ctx.fillStyle = '#FFFFFF';
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.font = "48px impact";
                    ctx.globalAlpha = 1.0;
                    ctx.textAlign = 'center';
                    ctx.fillText(text, 128, 48, p.canvas.width);
                    this.curEngine.updateTex(p.mesh, 'screen-'+p.name);
                    this.curEngine.updateETex(p.mesh, 'screen-'+p.name);
                    break;
                }
            }
        }

        async updateLevel(level) {

            const track = this.findTrack(level);

            if(this.currentLevel !== null) {
                if(this.trackThumbs[this.currentLevel].road){
                    this.curEngine.removeMeshChild(this.trackPod, this.trackThumbs[this.currentLevel].road);
                    this.curEngine.removeMesh(this.trackThumbs[this.currentLevel].road);
                }
            }

            if(level !== null) {

                if (!this.trackThumbs[level])
                    await this.createTrackThumbTex(track);

                this.curEngine.setTex(this.levelThumb.o, this.levelThumb.m.name, this.trackThumbs[level].tex);
                this.setScreenText('levelname', track.name);

                if(this.trackThumbs[level].road){
                    this.trackThumbs[level].road.position.set(0, 0.5, 0);
                    this.trackThumbs[level].road.meshGPU = this.curEngine.addMesh(this.trackThumbs[level].road);

                    this.curEngine.addMeshChild(this.trackPod, this.trackThumbs[level].road);
                }
            }

            this.updateTrackRanks(track);

            this.currentLevel = level;

            if (track === null) {
                this.setStartable(false);
                this.infoMessage = 'select track';
            }else if (this.world.myCar === null) {
                this.setStartable(false);
                    this.infoMessage = 'select car';
            } else {
                this.setStartable(true);
                this.infoMessage = null;
            }
            
            this.updateInfoBlock( this.infoMessage);
        }
        
     
        unload(){
            this.phys.delete();
            this.phys= null;

             this.curEngine.destroyObj(this.map.worldMap);
             this.map.worldMap = null;

             this.curEngine.destroyObj(this.trackList);
             this.trackList = null;

            for(let w of this.wires){
                this.curEngine.destroyObj(w);
            }
            this.wires = [];

            for(let w of this.movingObjects){
                this.curEngine.destroyObj(w);
            }
            this.movingObjects = [];

            for(let w of this.ringObjects){
                this.curEngine.destroyObj(w);
                this.curEngine.destroyLight(w.rectLight);
            }
            this.ringObjects = [];

            for(let n =0; n< this.world.track.cyls.length;n++){
                const c = this.world.track.cyls[n];
                if(c.mesh)
                    this.curEngine.destroyObj(c.mesh);
            }
            this.world.track.cyls = [];

            for(let c of this.worldObjs){
                this.curEngine.removeMesh(c);
            }
            this.worldObjs=[];

            this.curEngine.destroyObj(this.walletBoard);
            this.curEngine.destroyObj(this.floor);
            this.curEngine.destroyObj(this.podcar);
            
            if(this.trackPod)
                this.curEngine.destroyObj(this.trackPod);

            this.walletBoard = null;
            this.floor = null;
            this.podcar = null;
            this.trackPod = null;
        }

        stop(){

            this.removeMainEvents();
            this.started = false;
            this.lobbyLoaded = false;

            if(this.renderMode === 2){
                cancelAnimationFrame(this.animReq);
                this.curEngine.addRenderPass('render' , null );
                this.curEngine.addRenderPass('shadow' , null );
                this.curEngine.addRenderPass('ui' , null );
                this.animReq = null;
            }else

                this.curEngine.renderer.setAnimationLoop(null );
    
            if(pingServers !== null){
                clearTimeout(pingServers);
                pingServers = null;
            }

            this.curEngine.stopMusic();

            this.phys.clearPhyTrack(this.world.track);

            this.panels = [];
            this.buttons =  [];
            this.currentLevel= null;

            if(this.initDMGTxt !== null){
                this.curEngine.removeMesh(this.initDMGTxt);
                this.curEngine.destroyObj(this.initDMGTxt);
                this.initDMGTxt=null;
            }

            if(this.dmgMesh !== null){
                this.curEngine.removeMesh(this.dmgMesh);
                this.curEngine.destroyObj(this.dmgMesh);
                this.dmgMesh=null;
            }

            if(this.DMGTxt !== null){
                this.curEngine.removeMesh(this.DMGTxt);
                this.curEngine.destroyObj(this.DMGTxt);
                this.DMGTxt=null;
            }

            if(this.podcar)
                this.curEngine.removeMeshChild(this.podcar, this.carGroup);

            if(this.world.myCar){
                this.curEngine.removeCar(this.world.myCar);
                this.curEngine.destroyObj(this.world.myCar.ChassisMesh);

                for(let w of this.world.myCar.wheels){
                    this.curEngine.destroyObj(w.mesh);
                }
            }

            if(this.trackPod)
                this.curEngine.destroyObj(this.trackPod);

            this.curEngine.removeMesh(this.trackList);
                        
            this.curEngine.removeChar(this.npc1);
            this.curEngine.removeDialog(this.npc1);
            this.curEngine.destroyObj(this.npc1.avatarMesh);            
            this.curEngine.selectScene.remove(this.npc1.selectMesh);

            if(this.worldObjs){
                for(let c of this.worldObjs){
                    this.curEngine.removeMesh(c);
                }
            }
                
            for(let w of this.wires){
                this.curEngine.removeMesh(w);
            }
            
            for(let w of this.movingObjects){
                this.curEngine.removeMesh(w);
            }

            for(let w of this.ringObjects){
                this.curEngine.removeMesh(w);
                this.curEngine.removeLight(w.rectLight);
            }

            if(this.podcar)
                this.curEngine.removeMesh(this.podcar);

            this.curEngine.removeMesh(this.walletBoard);

            this.curEngine.removeMesh(this.floor);

            this.curEngine.removeMesh(this.carGroup);

            for(let n =0; n< this.world.track.cyls.length;n++){
                const c = this.world.track.cyls[n];
                if(c.mesh)
                    this.curEngine.removeMesh(c.mesh);
            }
            
            if(this.curEngine.isVr){

                this.curEngine.removeMesh(this.curEngine.vrRay2);
                this.curEngine.removeMesh(this.curEngine.vrTeleport2);

                this.curEngine.removeMesh(this.curEngine.vrRay1);
                this.curEngine.removeMesh(this.curEngine.vrTeleport1);
            }

            if(this.curEngine.rtEngine){
                this.curEngine.rtEngine.reset();
            }

            this.curFlag++;

            if(this.curEngine.sensor !== null)
                this.curEngine.sensor.stop();
        }

        addMainEvents(){

            
            if(this.curEngine.controller1)
                this.curEngine.controller1.addEventListener('selectstart', this.selectStart1func);

            if(this.curEngine.controller2)
                this.curEngine.controller2.addEventListener('selectstart', this.selectStart2Func);
            
            if(!this.eventObject)
                return;

            const self = this;

            this.eventObject.onMouseMove = function(e) {  self.mouseMoveFunc(e)};
            this.eventObject.onMouseDown = function(e) {  self.mouseDownFunc(e)};
            this.eventObject.onMouseUp = function(e) {  self.mouseUpFunc(e)};
            this.eventObject.onMouseOut = function(e) {  self.mouseOutFunc(e)};
            this.eventObject.onTouchStart = function(e) {  self.touchStartFunc(e)};
            this.eventObject.onTouchMove = function(e) {  self.touchMoveFunc(e)};
            this.eventObject.onTouchEnd = function(e) {  self.touchEndFunc(e)};
            this.eventObject.onKeyDown = function(e) {  self.keyDownFunc(e)};
            this.eventObject.onKeyUp = function(e) {  self.keyUpFunc(e)};

        }

        removeMainEvents(){

            if(this.curEngine.controller1)
                this.curEngine.controller1.removeEventListener('selectstart', this.selectStart1func);

            if(this.curEngine.controller2)
                this.curEngine.controller2.removeEventListener('selectstart', this.selectStart2Func);

            this.eventObject.onMouseMove = null;
            this.eventObject.onMouseDown = null;
            this.eventObject.onMouseUp = null;
            this.eventObject.onMouseOut = null;
            this.eventObject.onTouchStart = null;
            this.eventObject.onTouchMove = null;
            this.eventObject.onTouchEnd = null;
            this.eventObject.onKeyDown = null;
            this.eventObject.onKeyUp = null;

        }

        createRT(){

            this.walletBoard.rtMesh = this.curEngine.rtEngine.addMesh(this.walletBoard, RT_COAT, new Transformation3(this.walletBoard.position, this.walletBoard.quaternion));
            this.curEngine.rtEngine.drawMesh(this.walletBoard.rtMesh);
   
            this.trackList.rtMesh = this.curEngine.rtEngine.addMesh(this.trackList, RT_COAT, new Transformation3(this.trackList.position, this.trackList.quaternion));
            this.curEngine.rtEngine.drawMesh(this.trackList.rtMesh);

            /*
            this.npc1.avatarMesh.rtMesh = this.curEngine.rtEngine.addMesh(this.npc1.avatarMesh, RT_COAT, new Transformation3(this.npc1.avatarMesh.position, this.npc1.avatarMesh.quaternion));
            this.curEngine.rtEngine.drawMesh(this.npc1.avatarMesh.rtMesh);
            */
            

            for(let o of this.worldObjs){
                o.rtMesh = this.curEngine.rtEngine.addMesh(o, RT_COAT, new Transformation3(o.position, o.quaternion));
                this.curEngine.rtEngine.drawMesh(o.rtMesh);
            }

            for(let w of this.wires){
                w.rtMesh = this.curEngine.rtEngine.addMesh(w, RT_COAT, new Transformation3(w.position, w.quaternion));
                this.curEngine.rtEngine.drawMesh(w.rtMesh);
            }

                
            for(let w of this.movingObjects){
                w.rtMesh = this.curEngine.rtEngine.addMesh(w, RT_COAT, new Transformation3(w.position, w.quaternion));
                this.curEngine.rtEngine.drawMesh(w.rtMesh);
            }

            for(let w of this.ringObjects){
                w.rtMesh = this.curEngine.rtEngine.addMesh(w, RT_COAT, new Transformation3(w.position, w.quaternion));
                this.curEngine.rtEngine.drawMesh(w.rtMesh);
            }

            if(this.podcar){
                this.podcar.rtMesh = this.curEngine.rtEngine.addMesh(this.podcar, RT_COAT, new Transformation3(this.podcar.position, this.podcar.quaternion));
                this.curEngine.rtEngine.drawMesh(this.podcar.rtMesh);

                this.curEngine.rtEngine.enableRT(this.podcar);


            }

            for(let n =0; n< this.world.track.cyls.length;n++){
                const c =this.world.track.cyls[n];

                if(c.mesh){
                    c.mesh.rtMesh = this.curEngine.rtEngine.addMesh(c.mesh, RT_COAT, new Transformation3(c.mesh.position, c.mesh.quaternion));
                    this.curEngine.rtEngine.drawMesh(c.mesh.rtMesh);
                }
            }
        }

        async startLobbyInside(){

            const self = this;
            const curEngine = this.curEngine;
            const t= new Transformation3();

            if(self.lobbyLoaded)
                return;

            self.lobbyLoaded = true;
            
            const na = this.blockchaininfos.network.split('-');
            this.selectedNetwork = na[1];

            this.selectedBlockchain = this.blockchaininfos.bc_type;
            this.characterPHY = this.phys.addPhyCharacterController(this.character);

            this.curEngine.selectScene = new THREE.Scene();

            this.map.worldMap.traverse((child) => this.parseLobbyObj(child));

            this.npc1 = await this.world.track.addNPC(0, new THREE.Vector3(20, 0 , 15), 0, 'lobbynpc1');
            await this.curEngine.makeCharacter(this.npc1);
            this.curEngine.createSelectMesh(this.npc1);

            
            this.dialogSubLine = 0;
            this.dialogLine = 0;
            this.dialogAnswer = -1;

            this.npc1.ppos = new THREE.Vector3(this.npc1.pos.x, this.npc1.pos.y, this.npc1.pos.z);

            if((this.renderMode !== 2)||(this.firstStart === true)){

                this.npc1.pos.set(0, 0 , 0);
                this.npc1.angle = 0;
                this.npc1.scriptInstance.time = 0;
                this.npc1.scriptInstance.state = '';
                this.npc1.scriptInstance.line = 0;
                this.npc1.quat.setFromEuler(new THREE.Euler(0, this.npc1.angle, 0));
                this.npc1.rot.setFromEuler(new THREE.Euler(0, this.npc1.angle, 0));

                this.worldObjs = [];

                for(let c of this.map.worldMap.children){

                    if(c.name.startsWith('pod-car'))
                        continue;

                    const newObj = c.clone();

                    if (c.name === 'panel-wallets') {

                        this.walletBoard = newObj;

                        this.walletBoard.meshGPU = this.curEngine.addMesh(this.walletBoard);
                        this.curEngine.setMeshStatic(this.walletBoard, false);

                        for(let b of this.buttons){
                            if(b.panel === 'wallets') {
                                b.obj=this.walletBoard;
                            }
                        }

                    }else if (c.name === 'panel-tracklist') {

                        this.trackList = newObj;

                        this.trackListOAngle = this.trackList.rotation.clone();
                        
                        for(let im=0;im<this.trackList.material.length;im++) {
                            
                            if(!this.trackList.material[im].name.startsWith('screen-'))
                                continue;

                            const matCol = this.trackList.material[im].color.getHex();

                            const m = new THREE.MeshBasicMaterial(
                            {
                                color: matCol, 
                                name: this.trackList.material[im].name
                            });

                            m.color.setRGB(0.1, 0.2, 0.1);

                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');

                            const arr = m.name.split('-');
                            const trackid = parseInt(arr[1].substr(5)) - 1;
                            const infotype = arr[2];

                            if (infotype === 'thumb'){
                                canvas.width = 512;
                                canvas.height = 512;
                                m.map = this.curEngine.createTextureCanvas(canvas, false);
                            }

                            if (infotype === 'reward'){
                                canvas.width = 256;
                                canvas.height = 256;
                                m.map = this.curEngine.createTextureCanvas(canvas, false);
                            }

                            if ((infotype === 'bonus')|(infotype === 'time')|(infotype === 'name')){
                                canvas.width = 256;
                                canvas.height = 64;
                                m.map = this.curEngine.createTextureCanvas(canvas, false);
                            }

                               
                            const screen = { canvas: canvas, ctx: ctx, matCol: matCol, mesh: this.trackList, panel: 'tracklist', name: m.name };
                            this.trackPanel[trackid][infotype] = screen;
                            this.panels.push(screen);

                            this.trackList.material[im] = m;
                        }

                        this.trackList.meshGPU = this.curEngine.addMesh(this.trackList);
                        this.curEngine.setMeshStatic(this.trackList, false);

                    }else {
                        const o = newObj;

                       if(!c.name.startsWith('floor')){
                            o.meshGPU = this.curEngine.addMesh(o);
                            this.worldObjs.push(o);
                            this.curEngine.setMeshStatic(o, false);
                        }

                        if(c.name === 'panel-track')
                            this.levelThumb.o = o;

                        if(c.name === 'panel-account')
                            this.coinIcon.o = o;

                        if(c.name === this.mycarsTxt.o.name)
                            this.mycarsTxt.o = o;

                        if(c.name === self.freecarTxt.o.name)
                            self.freecarTxt.o = o;

                        for(let k in this.selectCarScreens){

                            const p = this.selectCarScreens[k];
                            if(p.mesh.name === c.name){
                                p.mesh = o;
                            }
                        }

                        for(let k in this.netTexts){

                            const p = this.netTexts[k];
                            if(p.o.name === c.name){
                                p.o = o;
                            }
                        }

                        
                        for(let b of this.buttons){
                            if(b.obj.name === c.name){
                                b.obj = o;
                            }
                        }

                        for(let p of this.panels){
                            if(p.mesh.name === c.name){
                                p.mesh = o;
                            }
                        }
                    }
                }
                //this.curEngine.setMeshStatic(this.map.worldMap, false);

           
                this.trackPod.meshGPU = this.curEngine.addMesh(this.trackPod, RT_DIFF, new Transformation3(this.trackPod.position));

                for(let w of this.wires){
                    w.meshGPU = this.curEngine.addMesh(w);
                    this.curEngine.setMeshStatic(w, false);
                }
                
                for(let w of this.movingObjects){
                    w.meshGPU = this.curEngine.addMesh(w);
                    this.curEngine.setMeshStatic(w, false);

                }

                for(let w of this.ringObjects){

                    const t = new Transformation3();

                    t.set(w.position, w.quaternion);
                    
                    w.meshGPU = this.curEngine.addMesh(w);

                    this.curEngine.updateTransform(w, t);
                    this.curEngine.setMeshStatic(w, false);

                }

                if(this.podcar){
                    this.podcar.meshGPU = this.curEngine.addMesh(this.podcar);
                    this.curEngine.setMeshStatic(this.podcar, false);

                }

                for(let n =0; n< this.world.track.cyls.length;n++){
                    const c = this.world.track.cyls[n];
                    if(c.mesh){
                        c.mesh.meshGPU = this.curEngine.addMesh(c.mesh);
                        this.curEngine.setMeshStatic(c.mesh, false);

                    }
                }
                this.curEngine.addCharObj(this.npc1);
                this.curEngine.addMesh(this.floor);
                this.firstStart = false;
            }

            if(this.curEngine.rtEngine)
                this.createRT();

            if(this.curEngine.rtEngine){
                this.curEngine.rtEngine.enableRT(this.floor);
            }

            this.carGroup = new THREE.Group();
            this.carGroup.name = 'car pod group';
            
            this.green_screen_img = document.createElement('img');
            this.green_screen_img.onload = function () {
                self.updateAccountTex();
                self.updateMission();
            }
            this.green_screen_img.src = 'assets/img/green_screen.webp';

            this.updateCarList();
            this.updateTrackList(this.currentTrackClass);
            this.updateWalletSelected();
            this.updateCoinIcon();
            this.updatePrizesTex();
            this.updateCarTex();
            this.updateCarStats('car');
            this.initSelectableCars();
            this.updateTrackRanks(null);
            
            this.curEngine.selectScene.add(this.npc1.selectMesh);
            this.phys.addPhyTrack(this.world.track);

            this.teleportPlayer('bar');
            
            updateServers();

            this.updateRaceType('practice');
            this.updateEnv('normal');
            this.updateSongs();
        }
        
        updateCarList() {

            const curEngine = this.curEngine;

            const prev = this.findPanelButton('selectcar', 'prev-car');
            const next = this.findPanelButton('selectcar', 'next-car');

            if ( this.carSelectMode === 1) {

                if ( this.firstElement === 0) {
                    prev.disabled = true;
                    prev.selected = false;
                    this.setButtonState(prev, 2);
                } else {
                    prev.disabled = false;
                    prev.selected = false;
                    this.setButtonState(prev, 0);
                }

                if (( this.firstElement + 4) >= this.blockchaininfos.assetLists['cars'].length) {
                    next.disabled = true;
                    next.selected = false;
                    this.setButtonState(next, 2);
                } else {
                    next.disabled = false;
                    next.selected = false;
                    this.setButtonState(next, 0);
                }
            } else {
                prev.disabled = true;
                this.setButtonState(prev, 2);
                next.disabled = true;
                this.setButtonState(next, 2);
            }

            for (let n = 0; n < 4; n++) {
                const id = n + 1;
                const p = this.selectCarScreens[n];
                const ctx = p.ctx;
                const color = '#' + p.matCol.toString(16);

                ctx.fillStyle = color;
                ctx.fillRect(0, 0, p.canvas.width, p.canvas.height);

                const b = this.findPanelButton('selectcar', 'selectcar' + (n + 1));

                if (( this.carSelectMode == 1) && ((n +  this.firstElement) < this.blockchaininfos.assetLists['cars'].length)) {

                    const asset = this.blockchaininfos.assetLists['cars'][n +  this.firstElement];
                    const carImg = getAssetImage(asset, 'cars');
                    const img = document.createElement('img');
                    const carid = asset.id;

                    b.selected = ((this.world.myCar !== null) && (this.world.myCar.carDef.id === carid) && (this.world.myCar.carDef.type === asset.type)) ? true : false;
                    b.disabled = false;

                    const bb = this.findPanelButton('selectcar', 'selectcar' + id + '-cont');
                    bb.disabled = false;

                    this.setButtonState(b, b.disabled ? 2 : b.selected ? 1 : 0);

                    img.onload = function () {

                        ctx.fillStyle = '#FFFFFF';
                        ctx.drawImage(img, 0, 32, p.canvas.width, p.canvas.height - 32);

                        ctx.fillStyle = '#000000';
                        ctx.strokeStyle = '#000000';
                        ctx.font = "48px impact";
                        ctx.globalAlpha = 1.0;
                        ctx.textAlign = 'center';
                        ctx.fillText(asset.name, 256, 48, p.canvas.width);
                        curEngine.updateTex(p.mesh, p.name);
                    }
                    img.crossOrigin = "";
                    img.src = curEngine.assetBase+'/assets/nfts/' + carImg;
                } else {

                    if ( this.carSelectMode == 1){
                        ctx.fillStyle = '#000000';
                        ctx.strokeStyle = '#000000';
                        ctx.font = "100px impact";
                        ctx.globalAlpha = 1.0;
                        ctx.textAlign = 'center';
                        ctx.fillText('no car', 256, 256, p.canvas.width);
                        curEngine.updateTex(p.mesh, p.name);
                    }
                    
                    const bb = this.findPanelButton('selectcar', 'selectcar' + id + '-cont');
                    bb.selected = false;
                    bb.disabled = true;

                    b.selected = false;
                    b.disabled = true;
                    this.setButtonState(b, 2);

                    curEngine.updateTex(p.mesh, p.name);
                }
            }
        }

        async getCarList() {
        
            this.blockchaininfos.assetLists = {cars : [], tires : [], motors : [], radars : [], batteries : [], weapons : []};

            if (this.blockchaininfos.logType >= 0) {
                const assTypes = this.blockchaininfos.bc_type === BC_SOLANA ? 4 : 3;
                await getAssets(this.blockchaininfos, ['cars'], assTypes);
            } else {
                await getDemoCars(this.blockchaininfos);
            }

            if (this.blockchaininfos.assetLists['cars']) {
                for (let n = 0; n < this.blockchaininfos.assetLists['cars'].length; n++) {

                    if (this.blockchaininfos.assetLists['cars'][n].id === this.blockchaininfos.selectedCarid) {
                        this.selectedAsset = n;
                        this.firstElement = n;
                    }
                }
            } else {
                this.selectedAsset = -1;
                this.firstElement = 0;
            }
        }

        async runXR(xrSession) {

            const worldRefSpace = await xrSession.requestReferenceSpace("local");
            if (worldRefSpace) {
                this.curEngine.baseReferenceSpace = worldRefSpace;
            }
        }

        async enableVR(on) {

            if (this.renderMode !== 0)
                return;

            if (on) {

                this.curEngine.isVr = true;
                const session = this.curEngine.renderer.xr.getSession();
                this.curEngine.initXRControllers(session);

                this.curEngine.vrRay1.matrixAutoUpdate = false;
                this.curEngine.vrTeleport1.visible = false;
                this.curEngine.addMesh(this.curEngine.vrRay1);
                this.curEngine.addMesh(this.curEngine.vrTeleport1);

                this.curEngine.vrRay2.matrixAutoUpdate = false;
                this.curEngine.vrTeleport2.visible = false;
                this.curEngine.addMesh(this.curEngine.vrRay2);
                this.curEngine.addMesh(this.curEngine.vrTeleport2);


                await this.runXR(session);
            } else {
                this.curEngine.isVr = false;
                this.curEngine.camera.position.set(0, 0, 0);
                this.curEngine.camera.quaternion.set(0, 0, 0, 1);

                this.curEngine.removeMesh(this.curEngine.vrRay2);
                this.curEngine.removeMesh(this.curEngine.vrTeleport2);

                this.curEngine.removeMesh(this.curEngine.vrRay1);
                this.curEngine.removeMesh(this.curEngine.vrTeleport1);

            }
        }
    }